import { data } from 'jquery';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class TsdService {
  addstockmaster: any;
  constructor(public http: HttpClient) { }

  serviceApiUrl: string = environment.serviceApiUrl;

  fetchByBeNumberAndClinicCode(beNumber, clinicCode) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchByBeNumberAndClinicCode?beNumber=" + beNumber + "&clinicCode=" + clinicCode);
  }
  fetchByProvisionalScheduleMaintenancePenaltyReportCompleted(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "ppmkpi/reportCompleted?stateId=" + stateId

    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }


    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByProvisionalScheduleMaintenancePenaltyReportNotCompletedReports(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
    let urlString = "ppmkpi/provisionalReportNotCompleted?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByProvisionalScheduleMaintenancePenaltyReportNotCompletedReportsExcel(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
    let urlString = "ppmkpi/provisionalReportNotCompletedForExcelAndPdf?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchAllLocationunAssignedTe(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,year,month){
      let data = ""
      if (stateId != null && stateId != "") {
        data += "stateId=" + stateId + "&"
      }
      if (districtId != null && districtId != "") {
        data += "districtId=" + districtId + "&"
      }
      if (circleId != null && circleId != "") {
        data += "circleId=" + circleId + "&"
      }
      if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
        data += "clinicCategoryId=" + clinicCategoryId + "&"
      }
      if (clinicTypeId != null && clinicTypeId != "") {
        data += "clinicTypeId=" + clinicTypeId + "&"
      }
      if (tabSetStatus != null && tabSetStatus != "") {
        data += "tabSetStatus=" + tabSetStatus + "&"
      }
      if (page != null && page != "") {
        data += "page=" + page + "&"
      }
      if (size != null && size != "") {
        data += "size=" + size + "&"
      }
      if (sortBy != null && sortBy != "") {
        data += "sortBy=" + sortBy + "&"
      }
      if (userId != null && userId != "") {
        data += "userId=" + userId + "&"
      }
      if (sortDirection != null && sortDirection != "") {
        data += "sortDirection=" + sortDirection + "&"
      }
      if (searchValue != null && searchValue != "") {
        data += "searchValue=" + searchValue + "&"
      }
      if (year != null && year != "") {
        data += "year=" + year + "&"
      }
      if (month != null && month != "") {
        data += "month=" + month + "&"
      }
      return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/fetchWorkRequestWorkOrderPagination?" + data);
  }
  fetchAllWRUnAssignedbyTe(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,year,month){
      let data = ""
      if (stateId != null && stateId != "") {
        data += "stateId=" + stateId + "&"
      }
      if (districtId != null && districtId != "") {
        data += "districtId=" + districtId + "&"
      }
      if (circleId != null && circleId != "") {
        data += "circleId=" + circleId + "&"
      }
      if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
        data += "clinicCategoryId=" + clinicCategoryId + "&"
      }
      if (clinicTypeId != null && clinicTypeId != "") {
        data += "clinicTypeId=" + clinicTypeId + "&"
      }
      if (tabSetStatus != null && tabSetStatus != "") {
        data += "tabSetStatus=" + tabSetStatus + "&"
      }
      if (page != null && page != "") {
        data += "page=" + page + "&"
      }
      if (size != null && size != "") {
        data += "size=" + size + "&"
      }
      if (sortBy != null && sortBy != "") {
        data += "sortBy=" + sortBy + "&"
      }
      if (userId != null && userId != "") {
        data += "userId=" + userId + "&"
      }
      if (sortDirection != null && sortDirection != "") {
        data += "sortDirection=" + sortDirection + "&"
      }
      if (searchValue != null && searchValue != "") {
        data += "searchValue=" + searchValue + "&"
      }
      if (year != null && year != "") {
        data += "year=" + year + "&"
      }
      if (month != null && month != "") {
        data += "month=" + month + "&"
      }
      return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/fetchWorkRequestWorkOrder?" + data);
    }
  addrequestAssigned(workrequest){
    return this.http.post<Observable<any>>(this.serviceApiUrl + "teBreakdownController/add", workrequest);
  }
  fetchByTeNumberConcat(leNumber){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/fetchBeNumberDetailsNew?leNumber=" +leNumber)
  }
  fetchPendingWObyTenumber(teNumber){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/fetchPendingWorkOrdersByBenumber?teNumber=" + teNumber);
  }
  fetchbyteIdConcat(stateId){

    return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/findAccessoriesByClinicIdCombined?stateId=" +stateId )
  }
  fetchByWOAgeingReportPPM(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
    let urlString = "ppmkpi/ageingReport?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }

  fetchByProvisionalScheduleMaintenancePenaltyReportNotCompleted(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "ppmkpi/provisionalReportNotCompleted?stateId=" + stateId
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByProvisionalScheduleMaintenancePenaltyReport(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "ppmkpi/report?stateId=" + stateId

    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }


    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByFinancialBdm(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "bdmkpi/report?stateId=" + stateId

    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }


    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByFinancialBdmCompleted(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "bdmkpi/reportCompleted?stateId=" + stateId

    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }


    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByFinancialBdmNotCompletedReports(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
    let urlString = "bdmkpi/provisionalReportNotCompleted?"
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByWOAgeningReportBDM(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
    let urlString = "bdmkpi/ageingReport?"
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByFinancialBdmNotCompleted(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "bdmkpi/reportNotCompleted?stateId=" + stateId
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByFinancialBdmNotCompletedreport(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "bdmkpi/provisionalReportNotCompleted?stateId=" + stateId
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByFinancialBdmNotCompletedreportExcel(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "bdmkpi/provisionalReportNotCompletedForExcelAndPdf?stateId=" + stateId
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByworkorderMaintenancePenaltyReportNotCompletedReports(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
    let urlString = "ppmkpi/provisionalReportNotCompleted?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByworkorderReports(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
    let urlString = "ppmkpi/workOrderReport?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByworkorderMaintenancePenaltyReportNotCompletedReportsClinic(stateId, circleId, districtId, clinicCategoryId, clinicTypeId,startDate,endDate,workGroupId,beCategoryId,clinicId) {
    let urlString = "ppmkpi/workOrderReport?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (startDate != null && startDate != '' && startDate != undefined) {
      urlString += "&startDate=" + startDate
    }

    if (endDate != null && endDate != '' && endDate != undefined) {
      urlString += "&endDate=" + endDate
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByworkorderbdmMaintenancePenaltyReportNotCompletedReports(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId,clinicId) {
    let urlString = "bdmkpi/workOrderReport?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByworkorderbdmMaintenancePenaltyReportNotCompletedReportsClinic(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, startDate, endDate,workGroupId,beCategoryId,clinicId) {
    let urlString = "bdmkpi/workOrderReport?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }
    if (startDate != null && startDate != '' && startDate != undefined) {
      urlString += "&startDate=" + startDate
    }

    if (endDate != null && endDate != '' && endDate != undefined) {
      urlString += "&endDate=" + endDate
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByworkorderLEbdmMaintenancePenaltyReportNotCompletedReports(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId,clinicId) {
    let urlString = "leWoReports/fetchLEBreakdownWoReport?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '' && clinicId != undefined) {
      urlString += "&clinicId=" + clinicId
    }

    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&leCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchByworkorderTEbdmMaintenancePenaltyReportNotCompletedReports(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
    let urlString = "leWoReports/fetchTEBreakdownWoReport?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }


    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (year != null && year != '' && year != undefined) {
      urlString += "&year=" + year
    }

    if (month != null && month != '' && month != undefined) {
      urlString += "&month=" + month
    }
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&teCategoryId=" + beCategoryId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchAllWOUnassigned() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=wrNotAssigned");
  }
  fetchAllTechWOUnassigned(userId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrder?tabSetStatus=wrNotAssigned&userId=" + userId);
  }
  fetchAllWONotAck() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=woNotAcknowledged");
  }
  fetchAllTechWONotAck(userId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrder?tabSetStatus=woNotAcknowledged&userId=" + userId);
  }
  fetchAllWONotRespond() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=woNotResponded");
  }
  fetchAllWOPendingCompletion() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=woPendingCompletion");
  }
  fetchAllTechWOPendingCompletion(userId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrder?tabSetStatus=woPendingCompletion&userId=" + userId);
  }

  fetchAllTechWOPendingCompletionSP(userId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/fetchWorkRequestWorkOrder?tabSetStatus=woPendingCompletion&userId=" + userId);
  }
  fetchAllWOCompleted() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=woCompleted");
  }
  fetchAllTechWOCompleted(userId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrder?tabSetStatus=woCompleted&userId=" + userId);
  }
  fetchAllWOClosed() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=woClosed");
  }
  fetchAllWRClosed() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=wrClosed");
  }
  fetchAllTechWOClosed(userId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrder?tabSetStatus=woClosed&userId=" + userId);
  }
  approveWorkOrder(data) {
    return this.http.put(this.serviceApiUrl + "workRequestTsd/approve", data);
  }
  approveWorkTEOrder(data) {
    return this.http.put(this.serviceApiUrl + "teBreakdownController/approve", data);
  }
  otrRequest(data) {
    return this.http.put(this.serviceApiUrl + "workRequestTsd/a", data);
  }
  otrRequestPpm(data) {
    return this.http.put(this.serviceApiUrl + "smWorkOrder/otrRaise", data);
  }
  otrRequestPpmSP(data) {
    return this.http.put(this.serviceApiUrl + "spWorkOrder/otrRaise", data);
  }
  approveTechWorkOrder(data) {
    return this.http.put(this.serviceApiUrl + "smWorkOrder/approve", data)
  }
  approveTechWorkOrderle(data) {
    return this.http.put(this.serviceApiUrl + "leWorkOrder/approve", data)
  }
  approveMailWorkOrder(data, serviceApiUrl) {
    return this.http.put(this.serviceApiUrl + "workRequestTsd/approve?serviceApiUrl=" + serviceApiUrl, data);
  }
  approveTechMailWorkOrder(data, serviceApiUrl) {
    return this.http.put(this.serviceApiUrl + "smWorkOrder/approve?serviceApiUrl=" + serviceApiUrl, data);
  }
  fetchAllWoCount(userId, stateId, circleId, districtId, clinicId,) {
    let strUrl = this.serviceApiUrl + "workRequestTsd/fetchCountWorkOrder?"

    if (stateId) {
      strUrl += "stateId=" + stateId + "&"
    }
    if (circleId) {
      strUrl += "circleId=" + circleId + "&"
    }
    if (districtId) {
      strUrl += "districtId=" + districtId + "&"
    }
    if (clinicId) {
      strUrl += "clinicId=" + clinicId + "&"
    }
    if (userId) {
      strUrl += "userId=" + userId + "&"
    }
    return this.http.get<Observable<any>>(strUrl);
  }

  fetchAllCWoCount(userId, stateId, circleId, districtId, clinicId,) {
    let strUrl = this.serviceApiUrl + "correctiveMaintenance/fetchCountWorkOrder?"

    if (stateId) {
      strUrl += "stateId=" + stateId + "&"
    }
    if (circleId) {
      strUrl += "circleId=" + circleId + "&"
    }
    if (districtId) {
      strUrl += "districtId=" + districtId + "&"
    }
    if (clinicId) {
      strUrl += "clinicId=" + clinicId + "&"
    }
    if (userId) {
      strUrl += "userId=" + userId + "&"
    }
    return this.http.get<Observable<any>>(strUrl);
  }
  rejectWRunAssigned(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "workRequestTsd/reject", data);
  }
  rejectTechWRunAssigned(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "smWorkOrder/reject", data);
  }
  fetchAssetListByClinicId(clinicId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "mAsset/fetchAssetListByClinicId?clinicId=" + clinicId);
  }
  fetchAssetAcessoriesListByClinicId(clinicId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/findAccessoriesByClinicId?clinicId=" + clinicId);
  }
  fetchAssetAcessoriesListByClinicIds(clinicId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/findAccessoriesByClinicIdPerReduce?clinicId=" + clinicId);
  }
  fetchBeCodeManufacturersByManufacturerId(manufacturerId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "beCodeAndManufacturer/fetchBeCodeManufacturerListByManufacturerId?manufacutrerId=" + manufacturerId);
  }

  addWRUnAssigned(workRequest) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "workRequestTsd/add", workRequest);
  }

  // fetchAllWRUnAssigned(tabSetStatus,stateId, circleId, districtId,clinicCategoryId,clinicTypeId) {
  //   return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=" + tabSetStatus);
   
  // }
  fetchAllWRUnAssigned(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,year,month) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (tabSetStatus != null && tabSetStatus != "") {
      data += "tabSetStatus=" + tabSetStatus + "&"
    }
    if (page != null && page != "") {
      data += "page=" + page + "&"
    }
    if (size != null && size != "") {
      data += "size=" + size + "&"
    }
    if (sortBy != null && sortBy != "") {
      data += "sortBy=" + sortBy + "&"
    }
    if (userId != null && userId != "") {
      data += "userId=" + userId + "&"
    }
    if (sortDirection != null && sortDirection != "") {
      data += "sortDirection=" + sortDirection + "&"
    }
    if (searchValue != null && searchValue != "") {
      data += "searchValue=" + searchValue + "&"
    }
    if (year != null && year != "") {
      data += "year=" + year + "&"
    }
    if (month != null && month != "") {
      data += "month=" + month + "&"
    }
    
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/wrUnassignedByFilter?" + data);
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?" + data);
  }
  // Replan Counters 
  fetchAllReplanCounting(stateId,circleId,districtId,clinicCategoryId) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/wrUnassignedByFilter?" + data);
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/smCounter?" + data);
  }
  fetchByScheduleMaintenance(clinicTypeId, clinicCategoryId, stateId, districtId, circleId) {

    let urlString = "mAsset/findByClinicCategoryAndType?stateId=" + stateId

    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicTypeId != null && clinicTypeId != '') {
      urlString += "&clinicTypeId=" + clinicTypeId
    }

    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }

    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }


    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);

  }
  fetchByScheduleMaintenanceSave(mAssetId, scheduledDate, scheduledDate2, remarks, status) {

    let data = ""
    if (mAssetId != null && mAssetId != "" && mAssetId != undefined) {
      data += "mAssetId=" + mAssetId + "&"
    }
    if (scheduledDate != null && scheduledDate != "" && scheduledDate != undefined) {
      data += "scheduledDate=" + scheduledDate + "&"
    }
    if (scheduledDate2 != null && scheduledDate2 != "" && scheduledDate2 != undefined) {
      data += "scheduledDate2=" + scheduledDate2 + "&"
    }
    if (remarks != null && remarks != "" && remarks != undefined) {
      data += "remarks=" + remarks + "&"
    }
    return this.http.get(this.serviceApiUrl + 'mAsset/updateSchedulingDate?status=y&' + data);

    // return this.http.get(this.serviceApiUrl + "mAsset/updateSchedulingDate?mAssetId=" + mAssetId + "&scheduledDate=" + scheduledDate + "&scheduledDate2=" + scheduledDate2 + "&status=y&remarks=" + remarks);

  }
  fetchAllWOInprogress() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=wrInProgress");
  }
  fetchAllWORejected() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrder?tabSetStatus=wrRejected");
  }
  // 
  fetchAllProblemReported() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "problemReported/all");
  }
  addProblemReported(problemReported) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "problemReported/add", problemReported);
  }
  editProblemReported(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "problemReported/update", data);
  }
  viewProblemReported(id) {
    // return this.http.put(this.serviceApiUrl + "problemReported/approvalProcess?id=" + id);
    return this.http.get<Observable<any>>(this.serviceApiUrl + "problemReported/approvalProcess?id=" + id);

  }
  fetchAllProblemIdentified() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "problemIdentified/all");
  }
  addProblemIdentified(problemIdentified) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "problemIdentified/add", problemIdentified);
  }
  editProblemIdentified(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "problemIdentified/update", data);
  }
  viewProblemIdentified(id) {
    // return this.http.put(this.serviceApiUrl + "problemReported/approvalProcess?id=" + id);
    return this.http.get<Observable<any>>(this.serviceApiUrl + "problemIdentified/approvalProcess?id=" + id);

  }
  fetchAllCasualFactor() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "causalFactor/all");
  }
  dropdowmcasualFactorProblemIdentified(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "causalFactor/getProblemIdentifiedByBeCategory?id=" + id);

  }
  addCasualFactors(casualFactor) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "causalFactor/add", casualFactor);
  }
  editCasualFactor(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "causalFactor/update", data);
  }

  viewCasualFactor(id) {
    // return this.http.put(this.serviceApiUrl + "problemReported/approvalProcess?id=" + id);
    return this.http.get<Observable<any>>(this.serviceApiUrl + "causalFactor/approvalProcess?id=" + id);

  }
  fetchAllttftManager() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "ttftManager/all");
  }
  addttftManager(ttftManager) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "ttftManager/add", ttftManager);
  }
  fetchAllttftManagerStateManager(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "ttftManager/getById?id=" + id);
  }
  editttftManager(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "ttftManager/update", data);
  }
  fetchAllStateManager() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stateManager/all");
  }
  addStateManager(stateManagerone) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "stateManager/add", stateManagerone);
  }
  addstockmasters(stockMaster) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "stockMaster/add", stockMaster);
  }
  fetchAllStateManagerID(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stateManager/getCicByCircleId?id=" + id);
  }
  fetchAllAGM() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "agm/all");
  }
  addAGM(agmManager) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "agm/add", agmManager);
  }
  fetchAllAGMStateManager(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "agm/getStateMngrByStateId?id=" + id);
  }
  editAGM(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "agm/update", data);
  }
  fetchAllSuperSpcial() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "superSpecialists/all");
  }
  newSuperSpcial() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "superSpecialists/generateSplCode");
  }
  addSuperSpcial(superSpecialistobj) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "superSpecialists/add", superSpecialistobj);
  }
  fetchAllttftManagerSuperSpcial() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "ttftManager/all");
  }
  editSuperSpcial(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "superSpecialists/update", data);
  }
  fetchAllttftManagerWorkGroup() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "m_work_group/all");
  }
  fetchAllttftManagerWorkGroupName() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "m_asset_category/all");
  }
  fetchttftManagersuperspecialdropdown(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "ttftManager/getSuperSpecialistByBeCategoryId?id=" + id);
  }
  editStateManager(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "stateManager/update", data);
  }
  fetchAllCircleInchargeID(clinicCategoryId, clinicId) {
    return this.http.get(this.serviceApiUrl + "circleInCharge/getTechnicianByClinicAndClinicCategoryId?clinicCategoryId=" + clinicCategoryId + "&clinicId=" + clinicId);
  }
  fetchAllCircleInchrge() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "circleInCharge/all");
  }
  addCircleIncharge(circleinchrge) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "circleInCharge/add", circleinchrge);
  }
  editCircleIncrge(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "circleInCharge/update", data);
  }
  fetchAllTechnicians() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "technicians/all");
  }
  addTechnicians(technicians) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "technicians/add", technicians);
  }
  editTechnicians(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "technicians/update", data);
  }
  fetchAllSpecialists() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "specialists/all");
  }
  addSpecifications(specialistsObj) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "specialists/add", specialistsObj);
  }
  editSpecialists(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "specialists/update", data);
  }
  fetchAllspecialistsBeCat() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "m_asset_category/all");
  }
  fetchAllspecialistsWorkGroup() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "m_work_group/all");
  }
  fetchAllKPIPnalty() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "repairPenalty/all");
  }
  addKPIPenalty(repairPenaltyObj) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "repairPenalty/add", repairPenaltyObj);
  }
  editKPIPenalty(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "repairPenalty/update", data);
  }
  fetchAllKPIPnaltyResponse() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "responsePenalty/all");
  }
  addKPIPenaltyResponse(responsePenaltyObj) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "responsePenalty/add", responsePenaltyObj);
  }
  editKPIPenaltyResponse(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "responsePenalty/update", data);
  }
  fetchAllKPIPnaltyPPM() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "ppmPenalty/all");
  }
  addKPIPenaltyPPM(ppmPenaltyObj) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "ppmPenalty/add", ppmPenaltyObj);
  }
  editKPIPenaltyPPM(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "ppmPenalty/update", data);
  }
  fetchAllKPIPenaltyUptime() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "uptimePenalty/all");
  }
  addKPIPenaltyUptime(ppmPenaltyObj) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "uptimePenalty/add", ppmPenaltyObj);
  }
  editKPIPenaltyUptime(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "uptimePenalty/update", data);
  }
  fetchAllProcessHierarchy() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "/priorityHierarchy/all");
  }
  fetchAllStoresDetail() {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "storesDetail/all");

  }

  fetchAllStoresLocation() {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "storesDetail/all");

  }


  addGM(gmObj) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "gm/add", gmObj);
  }
  fetchAllGM() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "gm/all");
  }
  fetchAllCeo() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "ceo/all");
  }
  addCEO(ceoObj) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "ceo/add", ceoObj);
  }
  editCEO(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "ceo/update", data);
  }
  editGM(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "gm/update", data);
  }
  savePurchaseRequest(data) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "newprprocess/addAll", data);
  }
  approvePurchaseRequest(data) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "newprprocess/approveAll", data);
  }
  fetchPurchaseRequest(stateId) {
    let urlString = "newprprocess/findAllPrGroup?"


    if (stateId != null && stateId != '' && stateId != undefined && stateId != 0) {
      urlString += "&stateId=" + stateId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);

    
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "newprprocess/findAllPrGroup?" + urlString);
  

  }
  fetchByPrGroup(prGroupNo) {
    // return this.http.get(this.serviceApiUrl + "newprprocess/findByPrGroup?prGroupNo=" + prGroupNo);
    // 
    return this.http.get(this.serviceApiUrl + "newprprocess/filterByPrGroupNo?prGroupNo=" + prGroupNo);


  }
  fetchPRWithoutMR(prGroupNo){
    return this.http.get(this.serviceApiUrl + "newprprocess/findByPrGroup?prGroupNo=" + prGroupNo);

  }
  saveStoreLocation(
    data,
    sparePartPicture,
  ) {
    const formData: FormData = new FormData();
    formData.append("storeDetail", JSON.stringify(data));
    // formData.append("sparePartImages", sparePartPicture);
    sparePartPicture.forEach((file) => { formData.append('sparePartImages', file); });
    console.log('goes', data)
    const req = new HttpRequest(
      "POST",
      `${this.serviceApiUrl}/storesDetail/add`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req);
  }

  // Schedule maintenance planning services ....

  // SM Planning approve ...

  approveScheduleStatus(data, stateCode, circleCode) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/approve?stateCode=" + stateCode + "&circleCode=" + circleCode, data);
  }

  monthWiseCount(circleId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/monthWiseCountPriorDate?circleId=" + circleId);
  }

  monthWiseCountByAssetCategory(ownershipId, assetCategoryId, circleId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/monthWiseCountByAssetCategoryPriorDate?ownershipId=" + ownershipId + "&assetCategoryId=" + assetCategoryId + "&circleId=" + circleId);
  }

  // SM Planing list ...
  fetchgroupBySMRefNumber() {
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/fetchgroupBySMRefNumber");
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smPlanningLog/fetchAll");
  }

  checkWetherAllAssetsApproved() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/checkWetherAllAssetsApproved");
  }

  fetchAllAssetsByDistrictAndClinic(clinicId) {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/findByClinic?clinicId=" + clinicId);
  }
  returntoStoreMR(data){
   return this.http.post<Observable<any>>(this.serviceApiUrl + "returnToStores/returnToStoresPartially", data);
  }
  findByCategory(assetCategoryId, stateId, circleId) {

    let urlString: string = "assetCategoryId=" + assetCategoryId

    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/findByCategory?" + urlString);
  }

  assignSMWorkOrder(assignSMWorkOrder) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "smWorkOrder/assignSMWorkOrder", assignSMWorkOrder);
  }

  approveAssigned(stateId, districtId, circleId, month, serviceApiUrl) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/approveAssigned?stateId=" + stateId + "&districtId=" + districtId + "&circleId=" + circleId + "&month=" + month + '&serviceApiUrl=' + serviceApiUrl);
  }


  getTheCount(stateId, circleId, districtId, clinicCategoryId) {

    let urlString = "scheduleMaintenance/smCounter?"

    if (stateId != null && stateId != '' && stateId != 0) {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != 0) {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '' && districtId != 0) {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != 0) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);

    // return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/smCounter");
  }




  // PPM Schedule Maintenance ...

  // http://127.0.0.1:8080/scheduleMaintenance/currentMonthWiseForPPM

  // testing ..

  currentMonthWiseForPPM() {

    // let url: string = "smWorkOrder/currentMonthWiseForPPM?" 

    // if (smUserId != null && smUserId != '' && smUserId != undefined) {
    //   url += "&smUserId=" + smUserId
    // }

    // if (cicUserId != null && cicUserId != '' && cicUserId != undefined) {
    //   url += "&cicUserId=" + cicUserId
    // }
    // return this.http.get<Observable<any>>(this.serviceApiUrl + url);


    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/currentMonthWiseForPPM");
  }
  // work order generation screen
  currentMonthWiseForPPMone(smUserId,cicUserId) {

    let url: string = "smWorkOrder/currentMonthWiseForWoPPM?" 

    if (smUserId != null && smUserId != '' && smUserId != undefined) {
      url += "&smUserId=" + smUserId
    }

    if (cicUserId != null && cicUserId != '' && cicUserId != undefined) {
      url += "&cicUserId=" + cicUserId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + url);


    // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/currentMonthWiseForPPM");
  }

  generateStockCode() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/generateStockCode");
  }


  fetchByFilterForLocation() {
    let periodMonth = new Date().getMonth() + 2;
    periodMonth = periodMonth == 13 ? 1 : periodMonth
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/filterByLocation?month=" + periodMonth);
  }

  fetchByFilteredForLocation(stateId,districtId, clinicCategoryId, clinicTypeId, circleId, clinicId) {
    let periodMonth = new Date().getMonth() + 2;
    periodMonth = periodMonth == 13 ? 1 : periodMonth

    let url: string = "smWorkOrder/filterByLocation?month=" + periodMonth

    if (stateId != null || stateId != '') {
      url += "&stateId=" + stateId
    }

    if (districtId != null || districtId != '') {
      url += "&districtId=" + districtId
    }
    if (clinicCategoryId != null || clinicCategoryId != '') {
      url += "&clinicCategoryId=" + clinicCategoryId
    }

    if (circleId != null || circleId != '') {
      url += "&circleId=" + circleId
    }

    if (clinicTypeId != null || clinicTypeId != '') {
      url += "&clinicTypeId=" + clinicTypeId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + url);
  }
  fetchByFilterForBECategory() {
    let periodMonth = new Date().getMonth() + 2;
    periodMonth = periodMonth == 13 ? 1 : periodMonth
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/filterByCategory?month=" + periodMonth);
  }
  fetchByFilteredForBECategory(workGroupId, ownershipId, beCategoryId, stateId, circleId) {
    let periodMonth = new Date().getMonth() + 2;
    periodMonth = periodMonth == 13 ? 1 : periodMonth


    let urlString: string = "month=" + periodMonth 

    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    // 
    if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
      urlString += "&workGroupId=" + workGroupId
    }
    if (ownershipId != null && ownershipId != '' && ownershipId != undefined) {
      urlString += "&ownershipId=" + ownershipId
    }
    if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
      urlString += "&beCategoryId=" + beCategoryId
    }
    console.log("hello", urlString)
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/filterByCategory?" + urlString);
  }



  // technician workload ...

  fetchTechnicianWorkLoad() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/technicianWorkLoad");
  }


  fetchTheUsersWorkLoad() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchUserWorkLoad");
  }

  assignTechncianFoClinicWise(clinicId, technicianWithCount, month) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<Observable<any>>(this.serviceApiUrl + "smWorkOrder/generateSmWo?clinicId=" + clinicId + "&month=" + month, technicianWithCount, httpOptions);
  }

  assignTechncianFobeCategoryWise(categoryId, technicianWithCount, month) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/generateSmWoBeCategory?assetCategoryId=" + categoryId + "&technicianWithCount=" + technicianWithCount + "&month=" + month);
  }

  fetchAllBEException(startDate, endDate) {
    return (
      this.http.get(this.serviceApiUrl + 'maintainBeExemption/getExemptedEquipments?startDate=' + startDate + '&endDate=' + endDate)
    );
  }
  fetchAllCasualFactorPrblemIdentified() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "/causalFactor/fetchAllByVerified");
  }
  fetchAllTechWoCount(userId, stateId, circleId, districtId, clinicId) {
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchCountWorkOrder?userId=" + userId);
    let strUrl = this.serviceApiUrl + "smWorkOrder/fetchCountWorkOrder?"

    if (stateId) {
      strUrl += "stateId=" + stateId + "&"
    }
    if (circleId) {
      strUrl += "circleId=" + circleId + "&"
    }
    if (districtId) {
      strUrl += "districtId=" + districtId + "&"
    }
    if (clinicId) {
      strUrl += "clinicId=" + clinicId + "&"
    }
    if (userId) {
      strUrl += "userId=" + userId + "&"
    }
    return this.http.get<Observable<any>>(strUrl);
  }

  fetchByPublicHolidayState(stateId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "publicStateHoliday/fetchByStateId?stateId=" + stateId)
  }
  fetchBySchoolHolidayState(stateId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "schoolStateHoliday/fetchByStateId?stateId=" + stateId)
  }

  forwardSMPlan(circleRefNumber, serviceApiUrl) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/approveStateManager?circleRefNumber=" + circleRefNumber + '&serviceApiUrl=' + serviceApiUrl)
  }
  resendSMPlan(circleRefNumber, serviceApiUrl) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/resendMailStateMgr?circleRefNumber=" + circleRefNumber + '&serviceApiUrl=' + serviceApiUrl)
  }
  fetchgroupByFilterSMRefNumber(stateId, circleId, districtId, clinicCategoryId) {

    let urlString = "smPlanningLog/fetchAll?stateId=" + stateId

    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  savePendingCompletionFiles(
    data,
    file1,
    file2,
    file3,
  ) {
    const formData: FormData = new FormData();
    formData.append("workRequestStringObj", JSON.stringify(data));
    formData.append("checkList", file2);
    formData.append("electricityReportFile", file3);
    formData.append("file3", file1);
    const req = new HttpRequest(
      "PUT",
      `${this.serviceApiUrl}smWorkOrder/approveWithFile`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req);
  }
  savePpmProposedForBERWithFiles(
    data,
    categoryCheckList,
    electricSafetyReport,
    otherDocument,
    formB12
  ) {
    const formData: FormData = new FormData();
    formData.append("workRequestStringObj", JSON.stringify(data));
    formData.append("checkList", categoryCheckList);
    formData.append("electricityReportFile", electricSafetyReport);
    formData.append("file3", otherDocument);
    formData.append("formB12", formB12);
    const req = new HttpRequest(
      "PUT",
      `${this.serviceApiUrl}smWorkOrder/approveWithFile`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req);
  }
  saveBreakDownPendingCompletionFiles(
    data,
    serviceNotificationFormFile,
    policeReportFile,
    Kewpa15File,
  ) {
    const formData: FormData = new FormData();
    formData.append("workRequestStringObj", JSON.stringify(data));
    formData.append("checkList", serviceNotificationFormFile);
    formData.append("electricityReportFile", Kewpa15File);
    formData.append("file3", policeReportFile);
    const req = new HttpRequest(
      "PUT",
      `${this.serviceApiUrl}workRequestTsd/approveWithFile`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req);
  }
  saveProposedForBERWithFiles(
    data,
    serviceNotificationFormFile,
    formB12,
    policeReportFile,
    Kewpa15File
  ) {
    const formData: FormData = new FormData();
    formData.append("workRequestStringObj", JSON.stringify(data));
    formData.append("checkList", serviceNotificationFormFile);
    formData.append("formB12", formB12);
    formData.append("electricityReportFile", Kewpa15File);
    formData.append("file3", policeReportFile);
    const req = new HttpRequest(
      "PUT",
      `${this.serviceApiUrl}workRequestTsd/approveWithFile`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req);
  }
  // Replan service ....


  // fetchDataByClinicForRePlan
  fetchDataByClinicForRePlan(stateId, districtId, circleId, clinicTypeId) {

    let urlString: string = '';

    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '') {
      urlString += "&clinicTypeId=" + clinicTypeId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchDataByClinicForRePlan?stateId=" + stateId + "&circleId=" + circleId + urlString + "&screenFlag=Holiday");
  }
  fetchDataByClinicForRePlanAddorRemove(stateId, districtId, circleId, clinicTypeId) {

    let urlString: string = '';

    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '') {
      urlString += "&clinicTypeId=" + clinicTypeId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchDataByClinicForRePlan?stateId=" + stateId + "&circleId=" + circleId + urlString + "&screenFlag=Equipments");
  }

  fetchDataByTechnicianForRePlan(stateId, districtId, circleId, clinicTypeId) {

    let urlString: string = '';

    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null && clinicTypeId != '') {
      urlString += "&clinicTypeId=" + clinicTypeId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchDataByTechnicianForRePlan?stateId=" + stateId + "&circleId=" + circleId + urlString + "&screenFlag=Holiday");
  }
  fetchDataByTechnicianForRePlanAddEquipment(beCategoryId, workGroupId, fromData, toData) {
    let urlString: string = '';

    if (beCategoryId != null && beCategoryId != '') {
      urlString += "&beCategoryId=" + beCategoryId
    }

    if (workGroupId != null && workGroupId != '') {
      urlString += "&workGroupId=" + workGroupId
    }
    if (fromData != null && fromData != '') {
      urlString += "&fromData=" + fromData
    }

    if (toData != null && toData != '') {
      urlString += "&toData=" + toData
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchByCategory?" + urlString + "&screenFlag=Equipments");

  }
  fetchDataByTechnicianForRePlanAddHoliday(beCategoryId, workGroupId, fromData, toData, stateId, circleId) {
    let urlString: string = '';

    if (beCategoryId != null && beCategoryId != '') {
      urlString += "&beCategoryId=" + beCategoryId
    }

    if (workGroupId != null && workGroupId != '') {
      urlString += "&workGroupId=" + workGroupId
    }
    if (fromData != null && fromData != '') {
      urlString += "&fromData=" + fromData
    }

    if (toData != null && toData != '') {
      urlString += "&toData=" + toData
    }
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchByCategory?" + urlString + "&screenFlag=Holiday");


  }
  fetchByClinicForReplanHoliday(clinicId: any) {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchByClinic?clinicId=" + clinicId + "&screenFlag=Holiday");

  }
  fetchByClinicForReplanHolidayAddRemove(clinicId: any) {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchByClinic?clinicId=" + clinicId + "&screenFlag=Equipments");

  }

  fetchByTechnicianForReplan(userId: any) {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchByTechnician?userId=" + userId + "&screenFlag=Equipments");

  }

  reschduleDate(scheduledDate, id, scheduleDate2) {
    if (scheduleDate2 == null || scheduleDate2 == '' || scheduleDate2 == undefined) {
      return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/updateReplan?scheduledDate=" + scheduledDate + "&id=" + id);
    }
    else {
      return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/updateReplan?scheduledDate=" + scheduledDate + "&id=" + id + "&scheduleDate2=" + scheduleDate2);
    }

  }
  fetchAllKPIUptimePenalty(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString = "bdmkpi/uptimePenaltyReport?"

    if (stateId != null && stateId != '' && stateId != 0) {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != 0) {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '' && districtId != 0) {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != 0) {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '' && clinicId != 0) {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '' && year != 0) {
      urlString += "&year=" + year
    }
    if (month != null && month != '' && month != 0) {
      urlString += "&month=" + month
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/uptimePenaltyReport");
  }

  // Replan Service Ends ...


  fetchMultipleDownload(recordId, sourceScreen) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "tMultipleFileUpload/fetchFiles?recordId=" + recordId + "&sourceScreen=" + sourceScreen);

  }
  downloadMultipleFile(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "tMultipleFileUpload/downloadFileById?id=" + id);

  }
  fetchByClinicForReplan(clinicId: any) {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchByClinic?clinicId=" + clinicId);

  }

  fetchDataForAddEquipmentReplan(stateId, districtId, circleId, clinicTypeId) {

    let urlString: string;

    if (districtId != null || districtId != '') {
      urlString += "&districtId=" + districtId
    }

    if (clinicTypeId != null || clinicTypeId != '') {
      urlString += "&clinicTypeId=" + clinicTypeId
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/fetchByScreenFlag?stateId=" + stateId + "&circleId=" + circleId + "&screenFlag=Equipments");
  }
  fetchByStockTypeId(stockTypeId: any) {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/findByStockType?stockTypeId=" + stockTypeId);

  }
  fetchByModelSpecificStock(beCodeAndManufacturerId, stockTypeId, stockCode) {
    let urlString: string;

    if (beCodeAndManufacturerId != null && beCodeAndManufacturerId != '') {
      urlString += "&beCodeAndManufacturerId=" + beCodeAndManufacturerId
    }
    if (stockTypeId != null && stockTypeId != '') {
      urlString += "&stockTypeId=" + stockTypeId
    }
    if (stockCode != null && stockCode != '') {
      urlString += "&stockCode=" + stockCode
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/findStockByCategoryModelAndCode?" + urlString);
  }
  fetchByStockTypeIdAndStockCode(stockTypeId: any, stockCode: any) {
    let urlString: string;

    if (stockTypeId != null && stockTypeId != '') {
      urlString += "&stockTypeId=" + stockTypeId
    }

    if (stockCode != null && stockCode != '') {
      urlString += "&stockCode=" + stockCode
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/findStockByCategoryModelAndCode?" + urlString);
  }
  fetchAllStockMaster() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/all");
  }
  fetchAllPublicHoliday() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "/publicHoliday/all");
  }
  fetchAllSchoolStateHoliday() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "/schoolHoliday/all");
  }
  fetchAllUptimes() {
    return this.http.get(this.serviceApiUrl + "smPenaltyReport/findPenaltySMPenaltyReport");
  }
  fetchAllrepair() {
    return this.http.get(this.serviceApiUrl + "responseRepairTimePenalty/fetchResponseRepairTimePenaltyReport");
  }
  rejectMR(data) {
    return this.http.put(this.serviceApiUrl + "mrsm/approve", data);

  }
  rejectRefactorMR(data) {
    return this.http.put(this.serviceApiUrl + "mrsmStock/approve", data);

  }
  approveCloseMRPPM(data) {
    return this.http.put(this.serviceApiUrl + "smWorkOrder/closeWo", data)
  }
  approveCloseMRPPMSP(data) {
    return this.http.put(this.serviceApiUrl + "spWorkOrder/closeWo", data)
  }
  approveCloseMRBreakdown(data) {
    return this.http.put(this.serviceApiUrl + "workRequestTsd/closeWo", data)
  }
  fetchPpmMR(id) {
    return this.http.get(this.serviceApiUrl + "mrsm/ppmMR?id=" + id)
  }
  fetchPpmRefactorMR(id) {
    return this.http.get(this.serviceApiUrl + "mrworkOrder/findAllPpm?ppmId=" + id)
  }
  fetchBreakdownMR(id) {
    return this.http.get(this.serviceApiUrl + "mrsm/breakdownMR?id=" + id)
  }
  fetchBdmRefactorMR(id) {
    return this.http.get(this.serviceApiUrl + "mrworkOrder/findAllBreakdown?id=" + id)
  }
  fetchByPPmMRNumber(mrNumber, id) {
    return this.http.get(this.serviceApiUrl + "mrsm/findMRByPPm?mrNumber=" + mrNumber + "&id=" + id)
  }
  fetchByBreakdownMRNumber(mrNumber, id) {
    return this.http.get(this.serviceApiUrl + "mrsm/findMRByMRNumberBreakdown?mrNumber=" + mrNumber + "&id=" + id)
  }

  approveReplan(stateId, districtId, screenFlag, circleId, serviceApiUrl) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/approve?stateId=" + stateId + "&districtId=" + districtId + "&screenFlag=" + screenFlag + "&circleId=" + circleId + '&serviceApiUrl=' + serviceApiUrl);
  }
  approveReplannew(stateId,districtId,circleId,clinicTypeId,screenFlag) {
    let urlString: string;

    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (clinicTypeId != null && clinicTypeId != '') {
      urlString += "&clinicTypeId=" + clinicTypeId
    }
    if (screenFlag != null && screenFlag != '') {
      urlString += "&screenFlag=" + screenFlag
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/approveHolidayInProgress?" + urlString);

    // return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/approveHolidayInProgress?stateId=" + stateId + "&districtId=" + districtId + "&circleId=" + circleId + "&clinicTypeId=" + clinicTypeId + "&screenFlag=" + screenFlag);
  }
  approveReplanRef(stateId, districtId, screenFlag, circleId, serviceApiUrl,circleRefNumber) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/approve?stateId=" + stateId + "&districtId=" + districtId + "&screenFlag=" + screenFlag + "&circleId=" + circleId + '&serviceApiUrl=' + serviceApiUrl + '&circleRefNumber=' + circleRefNumber);
  }
  addandmodify(stateId,districtId,circleId,screenFlag,serviceApiUrl,clinicId){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/approveHoliday?stateId=" + stateId + "&districtId=" + districtId + "&circleId=" + circleId + '&screenFlag=' + screenFlag +'&serviceApiUrl='+serviceApiUrl+'&clinicId='+clinicId);

  }
  // createMRraise(
  //   data,
  //   file,
  // ) {
  //   const formData: FormData = new FormData();
  //   formData.append("workRequestData", JSON.stringify(data));
  //   formData.append("file", file);
  //   console.log('goes', data)
  //   const req = new HttpRequest(
  //     "POST",
  //     `${this.serviceApiUrl}/workRequestTsd/raiseMR`,
  //     formData,
  //     {
  //       reportProgress: true,
  //       responseType: "json",
  //     }
  //   );
  //   return this.http.request(req);
  // }

  createMRraise(
    data,
    file,
  ) {
    const formData: FormData = new FormData();
    formData.append("workRequestData", JSON.stringify(data));
    formData.append("file", file);
    console.log('goes', file)
    // const req = new HttpRequest(
    //   "POST",
    //   `${this.serviceApiUrl}/smWorkOrder/raiseMR`,
    //   formData,
    //   {
    //     reportProgress: true,
    //     responseType: "json",
    //   }
    // );
    // return this.http.post(req);
    return this.http.post(this.serviceApiUrl + "workRequestTsd/raiseMR", formData);
  }
  createMRraisePPm(
    data,
    file,
  ) {
    const formData: FormData = new FormData();
    formData.append("workRequestData", JSON.stringify(data));
    formData.append("file", file);
    console.log('goes', file)
    // const req = new HttpRequest(
    //   "POST",
    //   `${this.serviceApiUrl}/smWorkOrder/raiseMR`,
    //   formData,
    //   {
    //     reportProgress: true,
    //     responseType: "json",
    //   }
    // );
    // return this.http.post(req);
    return this.http.post(this.serviceApiUrl + "smWorkOrder/raiseMR", formData);
  }
  createMRraisePPmSP(
    data,
    file,
  ) {
    const formData: FormData = new FormData();
    formData.append("workRequestData", JSON.stringify(data));
    formData.append("file", file);
    console.log('goes', file)
    // const req = new HttpRequest(
    //   "POST",
    //   `${this.serviceApiUrl}/smWorkOrder/raiseMR`,
    //   formData,
    //   {
    //     reportProgress: true,
    //     responseType: "json",
    //   }
    // );
    // return this.http.post(req);
    return this.http.post(this.serviceApiUrl + "spWorkOrder/raiseMR", formData);
  }
  fetchProblemIdentifiedByReported(problemReportedId) {
    return this.http.get(this.serviceApiUrl + "problemIdentifiedTemp/findByProblemReported?problemReportedId=" + problemReportedId)
  }
  fetchCausalFactorByProblemIdentified(problemIdentifiedId) {
    return this.http.get(this.serviceApiUrl + "causalFactorTemp/findByProblemIdentified?problemIdentifiedId=" + problemIdentifiedId)
  }
  fetchActionHistory(beCategory, manufacturer, model, problemReported) {
    return this.http.get(this.serviceApiUrl + "sparesHistory/actionHistory?beCategory=" + beCategory + "&manufacturer=" + manufacturer + "&model=" + model + "&problemReported=" + problemReported)
  }
  fetchAllProblemIdentifiedTemp() {
    return this.http.get(this.serviceApiUrl + "problemIdentifiedTemp/all")
  }
  fetchAllCasualFactorTemp() {
    return this.http.get(this.serviceApiUrl + "causalFactorTemp/all")
  }
  fetchByWorkOrderModelData(problemReportedId, beCategoryId) {
    return this.http.get(this.serviceApiUrl + "problemIdentifiedTemp/findByProblemReportedData?problemReportedId=" + problemReportedId + "&beCategoryId=" + beCategoryId);

  }
  fetchByWorkOrderModelDataTwo(problemId) {
    return this.http.get(this.serviceApiUrl + "problemIdentifiedTemp/fetchCauseByProblem?problemId=" + problemId);

  }
  monthWiseCountByClinic(clinicId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/monthWiseCountByClinic?clinicId=" + clinicId);
  }



  // new fahima code 
  fetchManufacturerAllModel(manufacturerId, beCategoryId, teCategoryId) {
    let urlString = "manufacturerOutOfBusiness/fetchManufacturerAllModel?manufacturerId=" + manufacturerId
    if (beCategoryId != null && beCategoryId != '') {
      urlString += "&beCategoryId=" + beCategoryId
    }
    if (teCategoryId != null && teCategoryId != '') {
      urlString += "&teCategoryId=" + teCategoryId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchManufacturerOutOfBusiness() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "manufacturerOutOfBusiness/all");
  }
  // editManufacturerOutOfBusiness(data) {
  //   return this.http.put<Observable<any>>(this.serviceApiUrl + "manufacturerOutOfBusiness/update", data);
  // }
  editManufacturerOutOfBusiness(updateManufacturer, supportDocument) {
    const formData: FormData = new FormData();
    formData.append("mobStringify", JSON.stringify(updateManufacturer));
    // formData.append("mobStringify",updateManufacturer)
    formData.append("supportDocument", supportDocument);
    console.log("manufacturer update", updateManufacturer);
    console.log("Support document", supportDocument)
    const req = new HttpRequest(
      "PUT",
      `${this.serviceApiUrl}/manufacturerOutOfBusiness/update`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req)
    // return this.http.post<Observable<any>>(this.serviceApiUrl + "manufacturerOutOfBusiness/add", ManufacturerObj);
  }
  addManufacturerOutOfBusiness(ManufacturerObj, supportDocument) {
    const formData: FormData = new FormData();
    formData.append("mobStringify", JSON.stringify(ManufacturerObj));
    formData.append("supportDocument", supportDocument);
    console.log("manufacturer add", ManufacturerObj);
    console.log("Support document", supportDocument)
    const req = new HttpRequest(
      "POST",
      `${this.serviceApiUrl}/manufacturerOutOfBusiness/add`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req)
    // return this.http.post<Observable<any>>(this.serviceApiUrl + "manufacturerOutOfBusiness/add", ManufacturerObj);
  }
  fetchupdateObsolete() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "updateObsolete/all");
  }
  // editupdateObsolete(data) {
  //   return this.http.put<Observable<any>>(this.serviceApiUrl + "updateObsolete/update", data);
  // }
  editupdateObsolete(updateObsolete, supportDocument) {
    const formData: FormData = new FormData();
    formData.append("updateObsoleteStringify", JSON.stringify(updateObsolete));
    // formData.append("mobStringify",updateManufacturer)
    formData.append("supportDocument", supportDocument);
    console.log("manufacturer update", updateObsolete);
    console.log("Support document", supportDocument)
    const req = new HttpRequest(
      "PUT",
      `${this.serviceApiUrl}/updateObsolete/update`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req)
    // return this.http.post<Observable<any>>(this.serviceApiUrl + "manufacturerOutOfBusiness/add", ManufacturerObj);
  }
  addupdateObsolete(ManufacturerObj, supportDocument) {
    const formData: FormData = new FormData();
    formData.append("updateObsoleteStringify", JSON.stringify(ManufacturerObj));
    formData.append("supportDocument", supportDocument);
    console.log("manufacturer add", ManufacturerObj);
    console.log("Support document", supportDocument)
    const req = new HttpRequest(
      "POST",
      `${this.serviceApiUrl}/updateObsolete/add`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req)
    // return this.http.post<Observable<any>>(this.serviceApiUrl + "manufacturerOutOfBusiness/add", ManufacturerObj);
  }
  fetchListEquipment(manufacturerId, beCategoryId, teCategoryId) {
    let urlString = "manufacturerOutOfBusiness/getAllEquipmentsByClinics?manufacturerId=" + manufacturerId
    if (beCategoryId != null && beCategoryId != '') {
      urlString += "&beCategoryId=" + beCategoryId
    }
    if (teCategoryId != null && teCategoryId != '') {
      urlString += "&teCategoryId=" + teCategoryId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  // 'http://localhost:8080/updateObsolete/getAllEquipmentsByClinics?beCategoryId=106&manufacturerId=997&modelId=4'
  fetchListEquipmentbeobsolete(manufacturerId, beCategoryId, teCategoryId, modelId) {
    let urlString = "updateObsolete/getAllEquipmentsByClinics?manufacturerId=" + manufacturerId + "&modelId=" + modelId
    if (beCategoryId != null && beCategoryId != '') {
      urlString += "&beCategoryId=" + beCategoryId
    }
    if (teCategoryId != null && teCategoryId != '') {
      urlString += "&teCategoryId=" + teCategoryId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  fetchPendingWObyBenumber(beNumber) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchPendingWorkOrdersByBenumber?beNumber=" + beNumber);
  }
  fetchAllAdminAssistant() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "adminAssitant/all");
  }
  addAdminAssistant(stateManagerone) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "adminAssitant/add", stateManagerone);
  }
  editAdminAssistant(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "adminAssitant/update", data);
  }
  fetchAllAdminExecutive() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "adminExecutive/all");
  }
  addAdminExecutive(stateManagerone) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "adminExecutive/add", stateManagerone);
  }
  editAdminExecutive(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "adminExecutive/update", data);
  }
  fetchAllDataEntryExecutive() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "dataEntryExecutive/all");
  }
  addDataEntryExecutive(stateManagerone) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "dataEntryExecutive/add", stateManagerone);
  }
  editDataEntryExecutive(data) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "dataEntryExecutive/update", data);
  }
  fetchAllBreakdownPenalty(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month, woNumber) {
    let urlString: string = '';
    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '') {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
    if (woNumber != null && woNumber != '') {
      urlString += "&woNumber=" + woNumber
    }
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/report?stateId="+stateId+"&circleId="+circleId +"&districtId="+districtId +"&clinicCategoryId="+clinicCategoryId +"&clinicId="+clinicId +"&year="+year +"&month="+month + urlString )
    return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/reportCompleted?" + urlString)
  }
  modifyBdmPenalty(workRequestStringObj, response, repair) {
    const formData: FormData = new FormData();
    formData.append("workRequestStringObj", JSON.stringify(workRequestStringObj));
    formData.append("response", response);
    formData.append("repair", repair);
    console.log("manufacturer add", response);
    console.log("Support document", repair)
    const req = new HttpRequest(
      "POST",
      `${this.serviceApiUrl}bdmkpi/modify`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req)
    // return this.http.post<Observable<any>>(this.serviceApiUrl + "bdmkpi/modify" ,data)
  }
  fetchCalulatedValue(targetDate, completionDate, stateId, clinicId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/calculatePenaltyDays?targetDate=" + targetDate + "&completionDate=" + completionDate + "&stateId=" + stateId + "&clinicId=" + clinicId)
  }
  fetchPenaltyHistory(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/fetchKpiHistory?id=" + id)
  }
  fetchAllPreventivePenalty(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month, woNumber) {
    let urlString: string = '';
    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '') {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
    if (woNumber != null && woNumber != '') {
      urlString += "&woNumber=" + woNumber
    }
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/report?stateId="+stateId+"&circleId="+circleId +"&districtId="+districtId +"&clinicCategoryId="+clinicCategoryId +"&clinicId="+clinicId +"&year="+year +"&month="+month + urlString )
    return this.http.get<Observable<any>>(this.serviceApiUrl + "ppmkpi/reportCompleted?" + urlString)
  }
  modifyPpmPenalty(workRequestStringObj, response) {
    const formData: FormData = new FormData();
    formData.append("workRequestStringObj", JSON.stringify(workRequestStringObj));
    formData.append("response", response);
    console.log("Support document", response)
    const req = new HttpRequest(
      "POST",
      `${this.serviceApiUrl}ppmkpi/modify`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req)
    // return this.http.post<Observable<any>>(this.serviceApiUrl + "ppmkpi/modify" ,data)

  }
  fetchStateWiseData(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString: string = '';
    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '') {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
   
    return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/summaryReport?" + urlString)
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/reportSummaryData?stateId=" +stateId+"&circleId="+circleId+"&districtId="+districtId+"&clinicCategoryId="+clinicCategoryId+"&clinicId="+clinicId+"&year="+year+"&month="+month)
  }
  fetchInternalGo(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString: string = '';
    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '') {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
   
    return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/summaryReport?" + urlString)
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/reportSummaryData?stateId=" +stateId+"&circleId="+circleId+"&districtId="+districtId+"&clinicCategoryId="+clinicCategoryId+"&clinicId="+clinicId+"&year="+year+"&month="+month)
  }
  fetchClinicWiseData(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
    let urlString: string = '';
    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    if (clinicId != null && clinicId != '') {
      urlString += "&clinicId=" + clinicId
    }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/summaryClinicReport?" + urlString)
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/summaryClinicReport?stateId=" +stateId+"&circleId="+circleId+"&districtId="+districtId+"&clinicCategoryId="+clinicCategoryId+"&clinicId="+clinicId+"&year="+year+"&month="+month)
  }

  // MR Stores Starts......

  fetchInternalAnalysisApprove(stateId, circleId, districtId, clinicCategoryId, year, month,internalAnalysisStatus,userId) {
    let urlString: string = '';
    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    // if (clinicId != null && clinicId != '') {
    //   urlString += "&clinicId=" + clinicId
    // }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
    if (internalAnalysisStatus != null && internalAnalysisStatus != '') {
      urlString += "&internalAnalysisStatus=" + internalAnalysisStatus
    }
    if (userId != null && userId != '') {
      urlString += "&userId=" + userId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/approveInternalAnalysisReport?" + urlString)
  }

  fetchInternalAnalysisReject(stateId, circleId, districtId, clinicCategoryId, year, month,internalAnalysisStatus,userId) {
    let urlString: string = '';
    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    // if (clinicId != null && clinicId != '') {
    //   urlString += "&clinicId=" + clinicId
    // }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
    if (internalAnalysisStatus != null && internalAnalysisStatus != '') {
      urlString += "&internalAnalysisStatus=" + internalAnalysisStatus
    }
    if (userId != null && userId != '') {
      urlString += "&userId=" + userId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/rejectInternalAnalysisReport?" + urlString)
  }

  fetchAllBreakdownMR() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "mrworkOrder/findAllMRBreakdown")
  }

  findAllProcessedMRBreakdown() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "mrworkOrder/findAllProcessedMRBreakdown")
  }

  fetchAllStocksForMrNumber(mrWoId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "mrsmStock/getStocksByMRNumber?mrWoId=" + mrWoId);
  }

  // Fetch BreakDown Data by id
  fetchBreakdownDataById(breakdownId) {
    // return this.http.get<Observable<any>>(this.serviceApiUrl + 'workRequestTsd/fetchBreakdownById?breakdownId=' + breakdownId);
    return this.http.get<Observable<any>>(this.serviceApiUrl + 'workRequestTsd/id?id=' + breakdownId + "&tabSetStatus=woPendingCompletion");
  }

  fetchDataById(breakdownId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + 'workRequestTsd/fetchBreakdownById?breakdownId=' + breakdownId);

  }

  fetchDataByIdPPm(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + 'smWorkOrder/id?id=' + id);

  }

  fetchDataByIdPPmSP(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + 'spWorkOrder/id?id=' + id);

  }

  // Save List of Mr Other Stores Request ...

  saveMrStocksOtherStores(datas) {
    return this.http.post(this.serviceApiUrl + "mrStockOtherStores/saveMrStocksOtherStores", datas);
  }

  updateMrStocksOtherStores(datas) {
    return this.http.put(this.serviceApiUrl + "mrStockOtherStores/updateMrStocksOtherStores", datas);
  }

  // Save issued and pr qty in stock mr mapping ...

  setQtyForMrStocks(data) {
    return this.http.put(this.serviceApiUrl + "mrsmStock/setQtyForMrStocks", data);
  }

  mrStatusUpdate(mrWoId) {

    return this.http.get(this.serviceApiUrl + "mrworkOrder/mrStatusUpdate?mrWoId=" + mrWoId)

  }


  // mrSetPrNumber
  mrSetPrNumber(mrWoId) {

    return this.http.get(this.serviceApiUrl + "mrworkOrder/mrSetPrNumber?mrWoId=" + mrWoId)

  }

  // MR Stores Stock Reuests Api hits Starts Here ..... 

  getStocksRequestedStores() {

    return this.http.get(this.serviceApiUrl + "mrStockOtherStores/getStocksRequestedStores");

  }

  getAllStocksRequestedByStore(id?: any) {

    if (id) {
      return this.http.get(this.serviceApiUrl + "mrStockOtherStores/getAllStocksRequestedByStore?storeLocationId=" + id);

    } else {
      return this.http.get(this.serviceApiUrl + "mrStockOtherStores/getAllStocksRequestedByStore");

    }

  }

  // updateApprovedQtyAndStatus(approvedQty, id) {

  //   return this.http.get(this.serviceApiUrl + "mrStockOtherStores/updateApprovedQtyAndStatus?approvedQty=" + approvedQty + "&id=" + id,{ responseType: "text" });

  // }
  
 updateApprovedQtyAndStatus(approvedQty, id,otherStoreIssueRemark) {
    

  return this.http.get(this.serviceApiUrl + "mrStockOtherStores/updateApprovedQtyAndStatus?approvedQty=" + approvedQty + "&id=" + id+ "&otherStoreIssueRemark=" + otherStoreIssueRemark,{ responseType: "text" });

}


  // MR Stores Stock Reuests Api hits Ends Here ..... 

  // MR Receive/ Issue List 
  // Issue from own stores
  issueFromOwnStoresSave(id, issuedQty,issuedDate,receivedDate,mrIssueRemark) {
    return this.http.get(this.serviceApiUrl + "mrStockOtherStores/updateStoreIssueQty?id=" + id + "&issuedQty=" + issuedQty + "&issuedDate=" + issuedDate+ "&receivedDate=" + receivedDate+ "&mrIssueRemark=" + mrIssueRemark, { responseType: "text" })
  }
  receiveFromOtherStoresSave(id, receivedQty, grnNumber, poNumber, ratePercent,receivedDate,mrReceiveRemark) {
    return this.http.get(this.serviceApiUrl + "mrStockOtherStores/updateStoreReciveQty?id=" + id + "&recivedQty=" + receivedQty + "&grnNumber=" + grnNumber + "&poNumber=" + poNumber + "&ratePercent=" + ratePercent + "&receivedDate=" + receivedDate + "&mrReceiveRemark=" + mrReceiveRemark,
      { responseType: "text" })
  }

  uopdateRejectPrQty(mrStockOtherStoresId, rejectQty){
    return this.http.get(this.serviceApiUrl + "mrStockOtherStores/mrPrReject?mrStockOtherStroesId="+mrStockOtherStoresId+"&rejectQty="+rejectQty,{responseType: "text"});
  }
  // MR Stores Ends........

  //   fetchByEquipmentAge(excemptionId) {
  //     return this.http.get<Observable<any>>(this.serviceApiUrl + "maintainBeExemption/beExemptions?exemptionId=" + excemptionId )
  //  }
  fetchByEquipmentAge(excemptionId, stateId, circleId, districtId, clinicCategoryId, clinicTypeId) {

    let urlString = "maintainBeExemption/beExemptions?exemptionId=" + excemptionId
    if (stateId != null && stateId != '') {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '') {
      urlString += "&circleId=" + circleId
    }
    if (districtId != null && districtId != '') {
      urlString += "&districtId=" + districtId
    }
    if (clinicCategoryId != null && clinicCategoryId != '') {
      urlString += "&clinicCategoryId=" + clinicCategoryId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }
  findTechnicianByCircle(circleId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "technicians/findByCircleId?circleId=" + circleId)
  }
  findSpecalistByState(stateId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "specialists/findByStateId?stateId=" + stateId)
  }
  techLoadByCircle(circleId) {
    let data = ""

    if (circleId != null && circleId != "" && circleId != undefined) {
      data += "circleId=" + circleId + "&"
    }
    return this.http.get(this.serviceApiUrl + 'smWorkOrder/technicianWorkLoadPpmbdm?' + data);
  }
  specLoadByState(stateId) {
    let data = ""

    if (stateId != null && stateId != "" && stateId != undefined) {
      data += "stateId=" + stateId + "&"
    }
    return this.http.get(this.serviceApiUrl + 'smWorkOrder/specialistWorkLoadPpmbdm?' + data);
  }


  transactionFetchByStockCode(stockCode) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/recentTransactions?stockCode=" + stockCode)
  }

  stockTransactionsByBeNumber(beNumber) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/stockTransactionsByBeNumber?beNumber=" + beNumber)
  }

  problemReportedByBecatId(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "problemReported/getByBeCategoryId?id=" + id)
  }
  problemIdentifiedByBecatId(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "problemIdentified/getByBeCategoryId?id=" + id)
  }
  findByStockId(stockId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMapping/findByStockId?stockId=" + stockId)
  }
  findByStockIdMappedWithLocation(stockId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/fetchStoreLocationStockMapping?stockId=" + stockId)
  }
  checkHoliday(mAssetId, scheduledDate, scheduledDate2, remarks, status) {

    let data = ""
    if (mAssetId != null && mAssetId != "" && mAssetId != undefined) {
      data += "mAssetId=" + mAssetId + "&"
    }
    if (scheduledDate != null && scheduledDate != "" && scheduledDate != undefined) {
      data += "scheduledDate=" + scheduledDate + "&"
    }
    if (scheduledDate2 != null && scheduledDate2 != "" && scheduledDate2 != undefined) {
      data += "scheduledDate2=" + scheduledDate2 + "&"
    }
    if (remarks != null && remarks != "" && remarks != undefined) {
      data += "remarks=" + remarks + "&"
    }
    return this.http.get(this.serviceApiUrl + 'mAsset/checkHoliday?status=y&' + data);

    // return this.http.get(this.serviceApiUrl + "mAsset/updateSchedulingDate?mAssetId=" + mAssetId + "&scheduledDate=" + scheduledDate + "&scheduledDate2=" + scheduledDate2 + "&status=y&remarks=" + remarks);

  }


  sendOtpToMailApproval(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/sentOtpToMail?id=" + id)

  }
  

  validateotpAppoveApproval(otp, districtId, clinicCategoryId, circleRefNumber, userId, serviceApiUrl, to) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/validateOtpFromMailApprove?otp=" + otp + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + "&circleRefNumber=" + circleRefNumber + "&userId=" + userId + "&serviceApiUrl=" + serviceApiUrl + "&to=" + to)

  }

  validateotpAppoveApprovalSP(otp, districtId, clinicCategoryId, circleRefNumber, userId, serviceApiUrl, to) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenanceSp/validateOtpFromMailApprove?otp=" + otp + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + "&circleRefNumber=" + circleRefNumber + "&userId=" + userId + "&serviceApiUrl=" + serviceApiUrl + "&to=" + to)

  }
  // SMReplan MailApproval
  appoveSmReplanMail(otp, districtId, clinicCategoryId,circleRefNumber, screenFlag, userId, serviceApiUrl, to) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/validateOtpFromMailApprove?otp=" + otp + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId +"&circleRefNumber="+circleRefNumber+ "&screenFlag=" + screenFlag + "&userId=" + userId + "&serviceApiUrl=" + serviceApiUrl + "&to=" + to)

  }
  sendOtpToMailApprovalReplan(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/sentOtpToMail?id=" + id)

  }

  validateotpAppoveReject(otp, districtId, clinicCategoryId, circleRefNumber, userId, serviceApiUrl, to, reject) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/validateOtpFromMailReject?otp=" + otp + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + "&circleRefNumber=" + circleRefNumber + "&userId=" + userId + "&serviceApiUrl=" + serviceApiUrl + "&to=" + to + "&reason=" + reject)
  }

  validateotpAppoveRejectSP(otp, districtId, clinicCategoryId, circleRefNumber, userId, serviceApiUrl, to, reject) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenanceSp/validateOtpFromMailReject?otp=" + otp + "&districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId + "&circleRefNumber=" + circleRefNumber + "&userId=" + userId + "&serviceApiUrl=" + serviceApiUrl + "&to=" + to + "&reason=" + reject)
  }

  validateotp(otp, userId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/validateOtpFromMail?otp=" + otp + "&userId=" + userId)

  }
  raiseStock(stockMasterObj, file) {
    const formData: FormData = new FormData();
    formData.append("stockMasterObj", JSON.stringify(stockMasterObj));
    formData.append("file", file);
    console.log("Support document", file)
    const req = new HttpRequest(
      "POST",
      `${this.serviceApiUrl}stockMaster/addStockwithImage`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req)
    // return this.http.post<Observable<any>>(this.serviceApiUrl + "ppmkpi/modify" ,data)

  }
  fetchAllTechStockData() {

    let urlString: string = '';
    // if (stateId != null && stateId != '') {
    //   urlString += "&stateId=" + stateId
    // }
    // if (circleId != null && circleId != '') {
    //   urlString += "&circleId=" + circleId
    // }
    // if (districtId != null && districtId != '') {
    //   urlString += "&districtId=" + districtId
    // }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/findByCreated?"+urlString);

    // return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/findByCreated")
  }
  // findStockImageById(id){
  //   return this.http.get<Observable<any>>(this.serviceApiUrl + "file/downladFileById?id=" + id)
  // }
  rejectStock(stockMasterDummy) {
    return this.http.put<Observable<any>>(this.serviceApiUrl + "stockMaster/reject", stockMasterDummy)
  }
  getProblemIdentifedByProblemReported(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "problemIdentified/getByProblemReportedId?id=" + id)
  }
  getProblemIdentifedByProblemReportedName(name) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "problemIdentified/getByProblemReportedName?name=" + name)
  }
  getByWrunAssignedById(id, status) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/id?id=" + id + "&tabSetStatus=" + status)
  }
  getByWrunAssignedByPPMId(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/id?id=" + id)
  }
  getByStockByWOId(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/findById?id=" + id)
  }
  getStockInfo(woId, woType) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/findByWorkOrder?woId=" + woId + "&woType=" + woType)
  }
  fetchByPreviousPbrHis(problemReportedId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/historyProblems?problemReportedId=" + problemReportedId)
  }

  fetchReportBO6(stateId, circleId, districtId, clinicTypeId, clinicId, month, year, clinicCategoryId) {


    let data = ""
    if (stateId != null && stateId != "" && stateId != undefined) {
      data += "stateId=" + stateId + "&"
    }
    if (circleId != null && circleId != "" && circleId != undefined) {
      data += "circleId=" + circleId + "&"
    }
    if (districtId != null && districtId != "" && districtId != undefined) {
      data += "districtId=" + districtId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "" && clinicTypeId != undefined) {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (clinicId != null && clinicId != "" && clinicId != undefined) {
      data += "clinicId=" + clinicId + "&"
    }
    if (month != null && month != "" && month != undefined) {
      data += "month=" + month + "&"
    }
    if (year != null && year != "" && year != undefined) {
      data += "year=" + year + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != undefined) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    return this.http.get<Blob>(this.serviceApiUrl + 'ppmreports/downloadB06?' + data, { responseType: 'blob' as 'json' });


  }


  fetchReportBO3(stateId, circleId, districtId, clinicTypeId, clinicId, month, year, clinicCategoryId) {


    let data = ""
    if (stateId != null && stateId != "" && stateId != undefined) {
      data += "stateId=" + stateId + "&"
    }
    if (circleId != null && circleId != "" && circleId != undefined) {
      data += "circleId=" + circleId + "&"
    }
    if (districtId != null && districtId != "" && districtId != undefined) {
      data += "districtId=" + districtId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "" && clinicTypeId != undefined) {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (clinicId != null && clinicId != "" && clinicId != undefined) {
      data += "clinicId=" + clinicId + "&"
    }
    if (month != null && month != "" && month != undefined) {
      data += "month=" + month + "&"
    }
    if (year != null && year != "" && year != undefined) {
      data += "year=" + year + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != undefined) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    return this.http.get<Blob>(this.serviceApiUrl + 'ppmreports/downloadB03?' + data, { responseType: 'blob' as 'json' });


  }

  addStockImage(stockMasterObj, file) {
    const formData: FormData = new FormData();
    formData.append("stockMasterObj", JSON.stringify(stockMasterObj));
    formData.append("file", file);

    const req = new HttpRequest(
      "POST",
      `${this.serviceApiUrl}stockMaster/addStockWithImageExisting`,
      formData,
      {
        reportProgress: true,
        responseType: "json",
      }
    );
    return this.http.request(req)

  }
  // Notification 

  notificationAdd(data) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "notificationview/add", data)

  }
  notificationAddAll(data) {
    return this.http.post<Observable<any>>(this.serviceApiUrl + "notificationview/addAll", data)

  }
  notificationfindClinicInCharge(clinicId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "notificationview/findClinicInCharge?clinicId=" + clinicId)


  }
  notificationfindStateManager(stateId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "notificationview/findStateManager?stateId=" + stateId)


  }
  notificationfindCircleIncharge(circleId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "notificationview/findCircleIncharge?circleId=" + circleId)


  }

  notificationfindDistrict(districtId, clinicCategoryId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "notificationview/findDistrict?districtId=" + districtId + "&clinicCategoryId=" + clinicCategoryId)
  }

  notificationfindAllTechnician(circleId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "notificationview/findAllTechnician?circleId=" + circleId)
  }
  notificationfindTechnician(userId) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "notificationview/findTechnician?userId=" + userId)
  }
  getByAssetCategoryId(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "m_asset_category/id?id=" + id)
  }
  fetchAllLocationUnassignedWR(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,year,month) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (tabSetStatus != null && tabSetStatus != "") {
      data += "tabSetStatus=" + tabSetStatus + "&"
    }
    if (page != null && page != "") {
      data += "page=" + page + "&"
    }
    if (size != null && size != "") {
      data += "size=" + size + "&"
    }
    if (sortBy != null && sortBy != "") {
      data += "sortBy=" + sortBy + "&"
    }
    if (userId != null && userId != "") {
      data += "userId=" + userId + "&"
    }
    if (sortDirection != null && sortDirection != "") {
      data += "sortDirection=" + sortDirection + "&"
    }
    if (searchValue != null && searchValue != "") {
      data += "searchValue=" + searchValue + "&"
    }
    if (year != null && year != "") {
      data += "year=" + year + "&"
    }
    if (month != null && month != "") {
      data += "month=" + month + "&"
    }
    
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/wrUnassignedByFilter?" + data);
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrderPagination?" + data);
  }
  
  fetchAllRejectedWR(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    workStatus,page,size,sortBy,sortDirection,searchValue) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workStatus != null && workStatus != "") {
      data += "workStatus=" + workStatus + "&"
    }
    if (page != null && page != "") {
      data += "page=" + page + "&"
    }
    if (size != null && size != "") {
      data += "size=" + size + "&"
    }
    if (sortBy != null && sortBy != "") {
      data += "sortBy=" + sortBy + "&"
    }
    if (sortDirection != null && sortDirection != "") {
      data += "sortDirection=" + sortDirection + "&"
    }
    if (searchValue != null && searchValue != "") {
      data += "searchValue=" + searchValue + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/wrRejectedByFilter?" + data);
  }
  notificationDelete(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "notificationview/delete?id=" + id)
  }


  // Process Hierarchy Starts Here :

  fetchReportess(userId) {
    return this.http.get(this.serviceApiUrl + "qubesTsdHierarchy/fetchReportess?id=" + userId);
  }
  fetchReportessByStateIdOrCircleId(stateId,circleId) {
    // let data = ""
    let urlString = 'qubesTsdHierarchy/fetchReportessStateWise?'
    if (stateId != null && stateId != "") {
      urlString += "stateId=" + stateId + "&"
    }
    if (circleId != null && circleId != "") {
      urlString += "circleId=" + circleId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "qubesTsdHierarchy/fetchReportess?stateId="+stateId+"&circleId="+circleId +"&"+data);
  }
  // Process Hierarchy Ends Here :

  inventoryReportData(storeId,stockId,year,month){

    return this.http.get(this.serviceApiUrl+"stockreport/reportByDate?storeId="+storeId+"&year="+year+"&month="+month+"&stockId="+stockId)
  
  }
  kpisummaryreportsforBDM(month,year){

    return this.http.get(this.serviceApiUrl+"kpireport/stateWiseBreakdown?month="+month+"&year="+year)
  
  }
  kpisummaryreportsforBDMCircleWise(month,year,stateId){

    return this.http.get(this.serviceApiUrl+"kpireport/circleWiseBreakdown?month="+month+"&year="+year+"&stateId="+stateId)
  
  }
  kpisummaryreportsforBDMDistrictWise(month,year,stateId,circleId){

    return this.http.get(this.serviceApiUrl+"kpireport/districtWiseBreakdown?month="+month+"&year="+year+"&stateId="+stateId+"&circleId="+circleId)
  
  }
  // kpiWoDataWithinResponse
  kpisummaryreportsforWithInKpiBDM(month,year,stateId,circleId, districtId){
    
    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
  
    return this.http.get<Observable<any>>(this.serviceApiUrl + "kpireport/kpiWoDataWithinResponse?month="+month+"&year="+year +"&"+data);

  
  }
  kpisummaryreportsforTotalWOBDM(month,year,stateId,circleId, districtId){
    
    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
  
    return this.http.get<Observable<any>>(this.serviceApiUrl + "kpireport/kpiWoDataTotal?month="+month+"&year="+year +"&"+data);

  
  }
  kpisummaryreportsforWithInKpiRepairBDM(month,year,stateId,circleId, districtId){
    
    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
  
    return this.http.get<Observable<any>>(this.serviceApiUrl + "kpireport/kpiWoDataWithinRepair?month="+month+"&year="+year +"&"+data);

  
  }
  // stateWisePPM
  kpisummaryreportsforPPM(month,year){

    return this.http.get(this.serviceApiUrl+"kpireport/stateWisePPM?month="+month+"&year="+year)
  
  }
  kpisummaryreportsforCircleWisePPM(month,year,stateId){

    return this.http.get(this.serviceApiUrl+"kpireport/circleWisePPM?month="+month+"&year="+year+"&stateId="+stateId)
  
  }
  kpisummaryreportsforDistrictWisePPM(month,year,stateId,circleId){

    return this.http.get(this.serviceApiUrl+"kpireport/districtWisePPM?month="+month+"&year="+year+"&stateId="+stateId+"&circleId="+circleId)
  
  }
  // kpiWoDataWithinPPM
  kpisummaryKPIWithPPMState(month,year,stateId,circleId, districtId){
    
    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
  
    return this.http.get<Observable<any>>(this.serviceApiUrl + "kpireport/kpiWoDataWithinPPM?month="+month+"&year="+year +"&"+data);

  
  }
  kpisummaryOutofPPMState(month,year,stateId,circleId, districtId){
    
    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
  
    return this.http.get<Observable<any>>(this.serviceApiUrl + "kpireport/kpiWoDataBeyondPPM?month="+month+"&year="+year +"&"+data);

  
  }
  kpisummaryTotalPPMState(month,year,stateId,circleId, districtId){
    
    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
  
    return this.http.get<Observable<any>>(this.serviceApiUrl + "kpireport/kpiWoDataTotalPPM?month="+month+"&year="+year +"&"+data);

  
  }
  fetchAssetListByClinicNumber(contactNumber) {

    return this.http.get<Observable<any>>(this.serviceApiUrl + "mAsset/fetchAssetListByClinicNumber?contactNumber="+contactNumber);

  }




// 
kpiOutofKpiRespondBdm(month,year,stateId,circleId, districtId){
    
  let data = ""
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&"
  }
  if (districtId != null && districtId != "") {
    data += "districtId=" + districtId + "&"
  }
  if (circleId != null && circleId != "") {
    data += "circleId=" + circleId + "&"
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + "kpireport/kpiWoDataBeyondResponse?month="+month+"&year="+year +"&"+data);


}
// 
kpiOutofKpiRepairpondBdm(month,year,stateId,circleId, districtId){
    
  let data = ""
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&"
  }
  if (districtId != null && districtId != "") {
    data += "districtId=" + districtId + "&"
  }
  if (circleId != null && circleId != "") {
    data += "circleId=" + circleId + "&"
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + "kpireport/kpiWoDataBeyondRepair?month="+month+"&year="+year +"&"+data);


}
fetchBYWOAgeingReportBDMPDF(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {

  let urlString = "bdmkpi/ageingReportWithMr?"

  if (stateId != null && stateId != '' && stateId != undefined) {

    urlString += "stateId=" + stateId

  }

  if (circleId != null && circleId != '' && circleId != undefined) {

    urlString += "&circleId=" + circleId

  }

  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {

    urlString += "&clinicCategoryId=" + clinicCategoryId

  }



  if (districtId != null && districtId != '' && districtId != undefined) {

    urlString += "&districtId=" + districtId

  }



  if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {

    urlString += "&clinicTypeId=" + clinicTypeId

  }

  if (year != null && year != '' && year != undefined) {

    urlString += "&year=" + year

  }



  if (month != null && month != '' && month != undefined) {

    urlString += "&month=" + month

  }

  if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {

    urlString += "&beCategoryId=" + beCategoryId

  }if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {

    urlString += "&workGroupId=" + workGroupId

  }



  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);

}

// Ageing report excel 
fetchbdmkpiwithMR(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {

  let urlString = "bdmkpi/reportNotCompletedWithMr?"

  if (stateId != null && stateId != '' && stateId != undefined) {

    urlString += "stateId=" + stateId

  }

  if (circleId != null && circleId != '' && circleId != undefined) {

    urlString += "&circleId=" + circleId

  }

  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {

    urlString += "&clinicCategoryId=" + clinicCategoryId

  }



  if (districtId != null && districtId != '' && districtId != undefined) {

    urlString += "&districtId=" + districtId

  }



  if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {

    urlString += "&clinicTypeId=" + clinicTypeId

  }

  if (year != null && year != '' && year != undefined) {

    urlString += "&year=" + year

  }



  if (month != null && month != '' && month != undefined) {

    urlString += "&month=" + month

  }

  if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {

    urlString += "&beCategoryId=" + beCategoryId

  }if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {

    urlString += "&workGroupId=" + workGroupId

  }



  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);

}

getStockById(id) {
  return this.http.get(this.serviceApiUrl + "stockMaster/id?id=" + id)
}
// Hake Reports MR Reports Start here ..

issueTransactionReport(storeId,stockCode,month,year,page,pageSize,sortBy,sortDirection,searchValue) {
  let urlString = "issueTransactionReport/stockTakeReport?";
  // let urlString = "issueTransactionReport/findByIssuedStock?"
  if (page != null && page != "") {
    urlString += "&page=" + page 
  }
  if (pageSize != null && pageSize != "") {
    urlString += "&size=" + pageSize 
  }
  if (sortBy != null && sortBy != "") {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != "") {
    urlString += "&sortDirection=" + sortDirection 
  }
  if (searchValue != null && searchValue != "") {
    urlString += "&searchValue=" + searchValue 
  }
  

  if (storeId != null && storeId != '' && storeId != undefined) {
    urlString += "&storeId=" + storeId
  }
  if (stockCode != null && stockCode != '' && stockCode != undefined) {
    urlString += "&stockCode=" + stockCode
  }
  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "issueTransactionReport/findByIssuedStock?storeId="+storeId+"&stockCode="+stockCode+"&month="+month+"&year="+year);
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

stockTakeReport(storeId,stockCode,month,year,page,pageSize,sortBy,sortDirection,searchValue) {
  let urlString = "issueTransactionReport/stockTakeReport?";
  // let urlString = "issueTransactionReport/findByIssuedStock?"
  if (page != null && page != "") {
    urlString += "&page=" + page 
  }
  if (pageSize != null && pageSize != "") {
    urlString += "&size=" + pageSize 
  }
  if (sortBy != null && sortBy != "") {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != "") {
    urlString += "&sortDirection=" + sortDirection 
  }
  if (searchValue != null && searchValue != "") {
    urlString += "&searchValue=" + searchValue 
  }
  

  if (storeId != null && storeId != '' && storeId != undefined) {
    urlString += "&storeId=" + storeId
  }
  if (stockCode != null && stockCode != '' && stockCode != undefined) {
    urlString += "&stockCode=" + stockCode
  }
  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "issueTransactionReport/findByIssuedStock?storeId="+storeId+"&stockCode="+stockCode+"&month="+month+"&year="+year);
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

issueTransactionReportFilter(storeId,stockCode,month,year,page,pageSize,sortBy,sortDirection,searchValue) {
  let urlString = "issueTransactionReport/issueTransactionReportFilter?";
  if (page != null && page != "") {
    urlString += "&page=" + page 
  }
  if (pageSize != null && pageSize != "") {
    urlString += "&size=" + pageSize 
  }
  if (sortBy != null && sortBy != "") {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != "") {
    urlString += "&sortDirection=" + sortDirection 
  }
  if (searchValue != null && searchValue != "") {
    urlString += "&searchValue=" + searchValue 
  }
  

  if (storeId != null && storeId != '' && storeId != undefined) {
    urlString += "&storeId=" + storeId
  }
  if (stockCode != null && stockCode != '' && stockCode != undefined) {
    urlString += "&stockCode=" + stockCode
  }
  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "issueTransactionReport/findByIssuedStock?storeId="+storeId+"&stockCode="+stockCode+"&month="+month+"&year="+year);
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

getInventoryMasterReport(storeId,stockTypeId,stockCode,page,pageSize,sortBy,sortDirection,searchValue) {
  let urlString = "inventoryMasterReport/getInventoryMasterReport?";
  if (page != null && page != "") {
    urlString += "&page=" + page 
  }
  if (pageSize != null && pageSize != "") {
    urlString += "&size=" + pageSize 
  }
  if (sortBy != null && sortBy != "") {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != "") {
    urlString += "&sortDirection=" + sortDirection 
  }
  if (searchValue != null && searchValue != "") {
    urlString += "&searchValue=" + searchValue 
  }
  

  if (storeId != null && storeId != '' && storeId != undefined) {
    urlString += "&storeId=" + storeId
  }
  if (stockTypeId != null && stockTypeId != '' && stockTypeId != undefined) {
    urlString += "&stockTypeId=" + stockTypeId
  }
  if (stockCode != null && stockCode != '' && stockCode != undefined) {
    urlString += "&stockCode=" + stockCode
  }
  

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "issueTransactionReport/findByIssuedStock?storeId="+storeId+"&stockCode="+stockCode+"&month="+month+"&year="+year);
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

// Hake Reports MR Reports Ends here ..



fetchAllTechWONotAckPagination(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?" + data) ;
}
fetchAllBdmWithPagination(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,year,month) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (year != null && year != "") {
    data += "year=" + year + "&"
  }
  if (month != null && month != "") {
    data += "month=" + month + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrderPagination?" + data) ;
}
kpisummaryreportsUptimeStateWise(month,year){

  return this.http.get(this.serviceApiUrl+"bdmkpi/uptimePenaltyReportStatewise?month="+month+"&year="+year)

}

kpisummaryreportsUptimeCircleWise(month,year,stateId){

  return this.http.get(this.serviceApiUrl+"bdmkpi/uptimePenaltyReportCirclewise?month="+month+"&year="+year+"&stateId="+stateId)

}


kpisummaryreportsUptimeDistrictWise(month,year,stateId,circleId){

  return this.http.get(this.serviceApiUrl+"bdmkpi/uptimePenaltyReportDistrictwise?month="+month+"&year="+year+"&stateId="+stateId+"&circleId="+circleId)

}

fetchAllApprovedProcessedBreakdownMR(page,size,sortBy,sortDirection,searchValue,stateId,circleId,districtId) {
  let data = ""
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (stateId != null && stateId != "" && stateId!=undefined) {
    data += "stateId=" + stateId + "&"
  }
  if (circleId != null && circleId != "" && circleId!=undefined) {
    data += "circleId=" + circleId + "&"
  }
  if (districtId != null && districtId != "" && districtId!=undefined) {
    data += "districtId=" + districtId + "&"
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mrworkOrder/findAllApprovedProcessedMRBreakdown?" + data)
}

fetchAllProcessedBreakdownMR(page,size,sortBy,sortDirection,searchValue,stateId,circleId,districtId) {
  let data = ""
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (stateId != null && stateId != "" && stateId!=undefined) {
    data += "stateId=" + stateId + "&"
  }
  if (circleId != null && circleId != "" && circleId!=undefined) {
    data += "circleId=" + circleId + "&"
  }
  if (districtId != null && districtId != "" && districtId!=undefined) {
    data += "districtId=" + districtId + "&"
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mrworkOrder/findAllProcessedMRBreakdownPagination?" + data)
}
getAllStocksRequestedByStorePagination(id,page,size,sortBy,sortDirection,searchValue,stateId) {
  let data = ""
  if (id != null && id != "") {
    data += "id=" + id + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&"
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mrStockOtherStores/getAllStocksRequestedByStorePagination?" + data);
}

fetchByProvisionalScheduleMaintenancePenaltyReportNotCompletedReportsWithMR(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
  let urlString = "ppmkpi/reportNotCompletedWithMr?" 
  if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "stateId=" + stateId
  }
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
    urlString += "&clinicTypeId=" + clinicTypeId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
    urlString += "&workGroupId=" + workGroupId
  }
  if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
    urlString += "&beCategoryId=" + beCategoryId
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByWOAgegingReportPPMpdf(stateId, circleId, districtId, clinicCategoryId, clinicTypeId, year, month,workGroupId,beCategoryId) {
  let urlString = "ppmkpi/ageingReportWithMr?" 
  if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "stateId=" + stateId
  }
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
    urlString += "&clinicTypeId=" + clinicTypeId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
    urlString += "&workGroupId=" + workGroupId
  }
  if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
    urlString += "&beCategoryId=" + beCategoryId
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchAllWorkorderDistrictUser() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/all");
}
fetchCompletedWRFilter(stateId, circleId, districtId, clinicCategoryId, clinicTypeId,
  workStatus,month,year,page,size,sortBy,sortDirection,searchValue): Observable<any[]> {

  let data = ""
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&"
  }
  
  if (circleId != null && circleId != "") {
    data += "circleId=" + circleId + "&"
  }
  if (districtId != null && districtId != "") {
    data += "districtId=" + districtId + "&"
  }
  if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
    data += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  if (clinicTypeId != null && clinicTypeId != "") {
    data += "clinicTypeId=" + clinicTypeId + "&"
  }
  if (workStatus != null && workStatus != "") {
    data += "workStatus=" + workStatus + "&"
  }
  if (month != null && month != "") {
    data += "month=" + month + "&"
  }
  if (year != null && year != "") {
    data += "year=" + year + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  return this.http.get<any[]>(this.serviceApiUrl + "workRequestTsd/wrCompletedByFilter?" + data);
}
fetchInprogressWRFilter(stateId, circleId, districtId, clinicCategoryId, clinicTypeId,
  workStatus,page,size,sortBy,sortDirection,searchValue): Observable<any[]> {

  let data = ""
  if (stateId != null && stateId != "") {
    data += "stateId=" + stateId + "&"
  }
  
  if (circleId != null && circleId != "") {
    data += "circleId=" + circleId + "&"
  }
  if (districtId != null && districtId != "") {
    data += "districtId=" + districtId + "&"
  }
  if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
    data += "clinicCategoryId=" + clinicCategoryId + "&"
  }
  if (clinicTypeId != null && clinicTypeId != "") {
    data += "clinicTypeId=" + clinicTypeId + "&"
  }
  if (workStatus != null && workStatus != "") {
    data += "workStatus=" + workStatus + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  return this.http.get<any[]>(this.serviceApiUrl + "workRequestTsd/wrInprogressByFilter?" + data);
}
notificationDeleteAll() {
  return this.http.delete<Observable<any>>(this.serviceApiUrl + "notificationview/deleteAll")
}

downloadChecklist(beCategoryId){
  return this.http.get<Blob>(this.serviceApiUrl+"ppmCheckList/download?beCategoryId="+beCategoryId, { responseType: 'blob' as 'json' })
}


fetchByProvisionalScheduleMaintenanceplanpreview(clinicTypeId, clinicCategoryId, clinicCode) {
  let urlString = "mAsset/smPlan?"

  if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
    urlString += "&clinicTypeId=" + clinicTypeId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (clinicCode != null && clinicCode != '' && clinicCode != undefined) {
    urlString += "&clinicCode=" + clinicCode
  }

  


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

fetchAllTechStockDataFiltered(stateId,circleId,districtId,page,size,sortBy,sortDirection,searchValue) {
  let urlString = "stockMaster/filteredStockRegistration?"
  if (stateId != null && stateId != '') {
    urlString += "&stateId=" + stateId
  }
  if (circleId != null && circleId != '') {
    urlString += "&circleId=" + circleId
  }
  if (districtId != null && districtId != '') {
    urlString += "&districtId=" + districtId
  }
  if (page != null && page != "") {
    urlString += "&page=" + page
  }
  if (size != null && size != "") {
    urlString += "&size=" + size
  }
  if (sortBy != null && sortBy != "") {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != "") {
    urlString += "&sortDirection=" + sortDirection
  }
  if (searchValue != null && searchValue != "") {
    urlString += "&searchValue=" + searchValue
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
fetchPRInformation(mrNumber){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mrStockOtherStores/get-list-of-purchase-request?mrNumber="+mrNumber)
}
fetchInventoryReport(storeId,stockTypeId,stockCode){
  let urlString = "inventoryMasterReport/fetchAllInventoryMaster?"
  if (storeId != null && storeId != '') {
    urlString += "&storeId=" + storeId
  }
  if (stockTypeId != null && stockTypeId != '') {
    urlString += "&stockTypeId=" + stockTypeId
  }
  if (stockCode != null && stockCode != '') {
    urlString += "&stockCode=" + stockCode
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
fetchInventoryReportModified(storeId,stockTypeId,stockCode){
  let urlString = "inventoryMasterReport/fetchAllInventoryMasterMonth?"
  if (storeId != null && storeId != '') {
    urlString += "&storeId=" + storeId
  }
  if (stockTypeId != null && stockTypeId != '') {
    urlString += "&stockTypeId=" + stockTypeId
  }
  if (stockCode != null && stockCode != '') {
    urlString += "&stockCode=" + stockCode
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
fetchMMDReport(stockCode,stockTypeId,storeLocationId,page,size,sortBy,sortDirection,searchValue){
  let urlString = "mrReportByStocks/mmdReportByStockWithMrDetails?"
  if (stockCode != null && stockCode != '') {
    urlString += "&stockCode=" + stockCode
  }
  if (stockTypeId != null && stockTypeId != '') {
    urlString += "&stockTypeId=" + stockTypeId
  }
  if (storeLocationId != null && storeLocationId != '') {
    urlString += "&storeLocationId=" + storeLocationId
  }
  if (page != null && page != "") {
    urlString += "&page=" + page
  }
  if (size != null && size != "") {
    urlString += "&size=" + size
  }
  if (sortBy != null && sortBy != "") {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != "") {
    urlString += "&sortDirection=" + sortDirection
  }
  if (searchValue != null && searchValue != "") {
    urlString += "&searchValue=" + searchValue
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
fetchMMDReportPDFExcel(stockCode,stockTypeId,storeLocationId){
  let urlString = "mrReportByStocks/mmdReportByStockWithMrDetailsForPdfAndExcel?"
  if (stockCode != null && stockCode != '') {
    urlString += "&stockCode=" + stockCode
  }
  if (stockTypeId != null && stockTypeId != '') {
    urlString += "&stockTypeId=" + stockTypeId
  }
  if (storeLocationId != null && storeLocationId != '') {
    urlString += "&storeLocationId=" + storeLocationId
  }
  
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
getStockCodeDataRFQ(stockCode){
  return this.http.get<Observable<any>>(this.serviceApiUrl + 'stockMaster/stockDetails?stockCode=' +stockCode)

}
getStockCodeDataRFQnew(storeId, stockId, month, year, bdmId, ppmId ) {
  let urlString = "issueTransactionReport/issueTransactionDetailReport?"
  if (storeId != null && storeId != '') {
    urlString += "&storeId=" + storeId
  }
  if (stockId != null && stockId != '') {
    urlString += "&stockId=" + stockId
  }
  if (month != null && month != '') {
    urlString += "&month=" + month
  }
  if (year != null && year != "") {
    urlString += "&year=" + year
  }
  if (bdmId != null && bdmId != "") {
    urlString += "&bdmId=" + bdmId
  }
  if (ppmId != null && ppmId != "") {
    urlString += "&ppmId=" + ppmId
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
getIssueTransactionReportPDFExcel(storeId, stockId, month, year) {
  let urlString = "issueTransactionReport/issuedTransacationPdfAndExcel?"
  if (storeId != null && storeId != '') {
    urlString += "&storeId=" + storeId
  }
  if (stockId != null && stockId != '') {
    urlString += "&stockId=" + stockId
  }
  if (month != null && month != '') {
    urlString += "&month=" + month
  }
  if (year != null && year != "") {
    urlString += "&year=" + year
  }
  


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
getHistoryData(stockId,stockTypeId,storeId,month,year ) {
  let urlString = "inventoryMasterReport/inventoryReportHistory?"
  if (stockId != null && stockId != '') {
    urlString += "&stockId=" + stockId
  }
  if (stockTypeId != null && stockTypeId != '') {
    urlString += "&stockTypeId=" + stockTypeId
  }
  if (storeId != null && storeId != '' && storeId != undefined) {
    urlString += "&storeId=" + storeId
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }
   return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
completeWoWithPBRStage(
  data,
  pberDoc,
) {
  const formData: FormData = new FormData();
  formData.append("stringObject", JSON.stringify(data));
  formData.append("pberDoc", pberDoc);
  console.log("Support document", pberDoc)
  
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}workRequestTsd/approvePBER`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
completeWoWithPbrToActStage(
  data,
  pberDoc,
) {
  const formData: FormData = new FormData();
  formData.append("stringObject", JSON.stringify(data));
  formData.append("pberDoc", pberDoc);
  console.log("Support document", pberDoc)
  
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}workRequestTsd/approveAct`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
fetchMultipleDownloadByText(variationText, sourceScreen) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "tMultipleFileUpload/fetchFilesVariationText?variationText=" + variationText + "&sourceScreen=" + sourceScreen);

}
completePpmWoWithPbrToActStage(
  data,
  pberDoc,
) {
  const formData: FormData = new FormData();
  formData.append("stringObject", JSON.stringify(data));
  formData.append("pberDoc", pberDoc);
  console.log("Support document", pberDoc)
  
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}smWorkOrder/approveAct`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
completePpmWoWithPbrToBerStage(
  data,
  pberDoc,
) {
  const formData: FormData = new FormData();
  formData.append("stringObject", JSON.stringify(data));
  formData.append("pberDoc", pberDoc);
  console.log("Support document", pberDoc)
  
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}smWorkOrder/approvePBER`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
saveReplan(stateId,circleId,districtId,screenFlag,userId,clinicCategoryId,clinicTypeId) {
  let urlString = "smreplan/approveRePlan?"
  if (stateId != null && stateId != '') {
    urlString += "&stateId=" + stateId
  }
  if (circleId != null && circleId != '') {
    urlString += "&circleId=" + circleId
  }
  if (districtId != null && districtId != '') {
    urlString += "&districtId=" + districtId
  }
  if (screenFlag != null && screenFlag != '') {
    urlString += "&screenFlag=" + screenFlag
  }
  if (userId != null && userId != '') {
    urlString += "&userId=" + userId
  }
  if (clinicCategoryId != null && clinicCategoryId != '') {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }
  // if (clinicTypeId != null && clinicTypeId != '') {
  //   urlString += "&clinicTypeId=" + clinicTypeId
  // }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
}
fetchReplanTableData(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + 'smPlanningLog/fetchAllRePlan')
}
fetchByCircleRefNumberSmReplan(stateId, districtId,circleId, clinicCategoryId, refNumber,clinicTypeId) {
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/refNumberGetValue?stateId=" + stateId + "&districtId=" + districtId  + "&circleId=" + circleId  + "&clinicCategoryId=" + clinicCategoryId  + "&refNumber=" + refNumber);
// findByClinicCategoryAndType
return this.http.get<Observable<any>>(this.serviceApiUrl + "smreplan/findByClinicCategoryAndType?stateId=" + stateId + "&districtId=" + districtId  + "&circleId=" + circleId  + "&clinicCategoryId=" + clinicCategoryId  + "&refNumber=" + refNumber+"&clinicTypeId"+clinicTypeId);

}
WorkOrderGenerationExcel(stateId,circleId,month,year){
    let urlString = "smWorkOrder/woGenerationExcelDetails?"
    if (stateId != null && stateId != '' && stateId != 0) {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != 0) {
      urlString += "&circleId=" + circleId
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
   
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
  
}
smReplanAddRemoveHoliday(beNumber,scheduledDate,scheduledDate2){
  let urlString = "smreplan/checkHoliday?"
  if (beNumber != null && beNumber != '') {
    urlString += "&beNumber=" + beNumber
  }
  if (scheduledDate != null && scheduledDate != '') {
    urlString += "&scheduledDate=" + scheduledDate
  }
 
  if (scheduledDate2 != null && scheduledDate2 != '') {
    urlString += "&scheduledDate2=" + scheduledDate2
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)

}


fetchReplanTableDatas(stateId, districtId,circleId, clinicCategoryId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "smPlanningLog/fetchAllRePlan?stateId=" + stateId + "&districtId=" + districtId  + "&circleId=" + circleId  + "&clinicCategoryId=" + clinicCategoryId);
}
fetchAllStockWithPagination(page,size,sortBy,sortDirection,searchValue) {
  let data = ""
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/findByCreatedPagination?" + data) ;
}
stockRejectPr(id,rejectReason) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mrStockOtherStores/rejectPr?id=" + id +"&rejectReason=" + rejectReason);

}
stockMoveToReplan(otherStoresId) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mrStockOtherStores/moveRePlan?otherStoresId=" + otherStoresId);

}
fetchByClinicIdConcat(clinicId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/findAccessoriesByClinicIdCombined?clinicId=" + clinicId);
}
fetchByBeNumberConcat(beNumber){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mAsset/fetchBeNumberDetailsNew?beNumber=" + beNumber);

}
fetchTableDataForReturn(id,userId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchIssuedMrStocks?id=" + id+"&userId="+userId);
}
stockReturnToStore(storeDetailsId,stockId,returnQty,mrWoId,returnReason) {
  let urlString = "mrsmStock/stocksReturnToStores?"

  if (storeDetailsId != null && storeDetailsId != '' && storeDetailsId != undefined) {
    urlString += "storeDetailsId=" + storeDetailsId
  }
  if (stockId != null && stockId != '' && stockId != undefined) {
    urlString += "&stockId=" + stockId
  }
  if (returnQty != null && returnQty != '' && returnQty != undefined) {
    urlString += "&returnQty=" + returnQty
  }
  if (mrWoId != null && mrWoId != '' && mrWoId != undefined) {
    urlString += "&mrWoId=" + mrWoId
  }
  if (returnReason != null && returnReason != '' && returnReason != undefined) {
    urlString += "&returnReason=" + returnReason
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchBDMInprogressSorting(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/sortByColor?" + data) ;
}
fetchBDMInprogressSortingnew(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/sortByColorCorrective?" + data) ;
}
fetchPPMMInprogressSorting(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/sortByColorPPM?" + data) ;
}

fetchCorrectiveInprogressSorting(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "correctiveMaintenance/sortByColorCorrective?" + data) ;
}
fetchStockMasterWithPagination(page,pageSize,sortBy,sortDirection,searchValue,workGroupId,stockTypeId) {
  let data = ""
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (pageSize != null && pageSize != "") {
    data += "pageSize=" + pageSize + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (workGroupId != null && workGroupId != "") {
    data += "workGroupId=" + workGroupId + "&"
  }
  if (stockTypeId != null && stockTypeId != "") {
    data += "stockTypeId=" + stockTypeId + "&"
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/fetAllStockMasterPagination?" + data) ;
}
fetchStockMasterGo(userId,stockTypeId,workGroupId) {
  let data = ""
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (stockTypeId != null && stockTypeId != "") {
    data += "stockTypeId=" + stockTypeId + "&"
  }
  if (workGroupId != null && workGroupId != "") {
    data += "workGroupId=" + workGroupId + "&"
  }
 
  return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/downloadStockMasterPdf?" + data) ;
}
// 
fetchStockInventoryPDF(storeId,stockTypeId,stockCode,userId) {
  let data = ""
  if (storeId != null && storeId != "") {
    data += "storeId=" + storeId + "&"
  }
  if (stockTypeId != null && stockTypeId != "") {
    data += "stockTypeId=" + stockTypeId + "&"
  }
  if (stockCode != null && stockCode != "") {
    data += "stockCode=" + stockCode + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
 
  return this.http.get<Observable<any>>(this.serviceApiUrl + "inventoryMasterReport/inventoryMasterPdfSendToEmail?" + data) ;
}
fetchStockInventoryExcel(storeId,stockTypeId,stockCode,userId) {
  let data = ""
  if (storeId != null && storeId != "") {
    data += "storeId=" + storeId + "&"
  }
  if (stockTypeId != null && stockTypeId != "") {
    data += "stockTypeId=" + stockTypeId + "&"
  }
  if (stockCode != null && stockCode != "") {
    data += "stockCode=" + stockCode + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
 
  return this.http.get<Observable<any>>(this.serviceApiUrl + "inventoryMasterReport/inventoryMasterExcelSendToEmail?" + data) ;
}
fetchStockMasterGoExcel(userId,stockTypeId,workGroupId) {
  let data = ""
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (stockTypeId != null && stockTypeId != "") {
    data += "stockTypeId=" + stockTypeId + "&"
  }
  if (workGroupId != null && workGroupId != "") {
    data += "workGroupId=" + workGroupId + "&"
  }
 
  return this.http.get<Observable<any>>(this.serviceApiUrl + "stockMaster/downloadStockMasterExcel?" + data) ;
}
fetchByStateManager(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/fetchByStateManager");
}
fetchBySpecialist(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/fetchBySpecialist");
}
fetchByCircleIncharge(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/fetchByCircleInCharge");
}
fetchByTechnician(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/fetchByTechnician");
}
generateStateManagerCode(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/generateStateManagerUserCode");
}
generateSpecialistCode(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/generateSpecialistUserCode");
}
generateCircleInchargeCode(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/generateCircleInChargeUserCode");
}
generateTechnicianCode(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/generateTechnicianUserCode");
}
saveStateManagerMapping(mappingDTO){
  return this.http.post<Observable<any>>(this.serviceApiUrl + "qubesTsdHierarchy/addUserReporteeMapping", mappingDTO);
}
fetchByStateManagerId(smUserId,reporteeDesignation){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/getSmReportes?smUserId=" + smUserId + "&reporteeDesignation=" + reporteeDesignation)
}
fetchByCircleInchargeId(cicUserId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/getCICReportes?cicUserId=" + cicUserId)
}
fetchReportingTechnician(techUserId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/getByTechnicianReporters?techUserId=" + techUserId)
}
fetchReportersById(reporteeId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/fetchReporters?reporteeId=" + reporteeId)
}
fetchInterStockTransfer(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "storesLocationStockMapping/fetchAll");
}
generateIssueNoteNo(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "mrStockOtherStores/generateIssueNoteNumber");
}
fetchByInterStockTransferCode(itsCode){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "storesLocationStockMapping/getInterTransferStores?itsCode=" + itsCode);
}
saveInterStockTransfer(newPRProcesses) {
  return this.http.post<Observable<any>>(this.serviceApiUrl + "storesLocationStockMapping/requestITS", newPRProcesses);
}
approveInterStockTransfer(processes) {
  return this.http.post<Observable<any>>(this.serviceApiUrl + "storesLocationStockMapping/approveITS", processes);
}
fetchByStoreStockId(storeId: any,stockTypeId: any, stockCode: any) {
  let urlString: string;
  if (storeId != null && storeId != '') {
    urlString += "&storeId=" + storeId
  }
  if (stockTypeId != null && stockTypeId != '') {
    urlString += "&stockTypeId=" + stockTypeId
  }
  if (stockCode != null && stockCode != '') {
    urlString += "&stockCode=" + stockCode
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "storesLocationStockMapping/fetchStoreLocationStockMapping?" + urlString);
}
fetchCalulatedAmount(targetDate, completionDate, stateId, clinicId) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "bdmkpi/calculatePPMPenalty?targetDate=" + targetDate + "&completionDate=" + completionDate + "&stateId=" + stateId + "&clinicId=" + clinicId)
}
fetchByFinancialBdmoverall(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "bdmkpi/provisionalFlatReports?stateId=" + stateId
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByFinancialBdmoverallExcelPdf(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "bdmkpi/provisionalFlatReportsForExcelAndPdf?stateId=" + stateId
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

fetchByProvisionalScheduleMaintenanceoverall(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "ppmkpi/provisionalFlatReports?stateId=" + stateId
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByProvisionalScheduleMaintenanceoverallExcel(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "ppmkpi/provisionalFlatReportsForExcelAndPdf?stateId=" + stateId
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByFinancialBdmoverallreport(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "ppmkpi/flatReports?stateId=" + stateId

  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByFinancialBdmoverallreportbdm(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "bdmkpi/flatReports?stateId=" + stateId
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }

  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByFinancialBdmCompletedNew(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "bdmkpi/provisionalReportCompleted?stateId=" + stateId

  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByFinancialBdmCompletedNewExcel(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "bdmkpi/provisionalReportCompletedForExcelAndPdf?stateId=" + stateId

  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByProvisionalScheduleMaintenancePenaltyReportCompletedNew(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "ppmkpi/provisionalReportCompleted?stateId=" + stateId

  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByProvisionalScheduleMaintenancePenaltyReportCompletedNewExcelPdf(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month) {
  let urlString = "ppmkpi/provisionalReportCompletedForExcelAndPdf?stateId=" + stateId

  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchByProvisionalScheduleMaintenancePenaltyReportCompletedNewWO(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month,woNumber) {
  let urlString = "ppmkpi/provisionalReportCompleted?"


  if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "&stateId=" + stateId
  }
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (woNumber != null && woNumber != '' && woNumber != undefined) {
    urlString += "&woNumber=" + woNumber
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}


fetchByFinancialBdmCompletedNewWO(stateId, circleId, districtId, clinicCategoryId, clinicId, year, month,woNumber) {
  let urlString = "bdmkpi/provisionalReportCompleted?"

  if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "&stateId=" + stateId
  }
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (woNumber != null && woNumber != '' && woNumber != undefined) {
    urlString += "&woNumber=" + woNumber
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

initiateCorrective(data) {
  return this.http.post(this.serviceApiUrl + "correctiveMaintenance/initiateCorrectiveMaintenance", data)
}

fetchAllCwoWithPagination(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,year,month) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (year != null && year != "") {
    data += "year=" + year + "&"
  }
  if (month != null && month != "") {
    data += "month=" + month + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "correctiveMaintenance/fetchWorkRequestWorkOrderPagination?" + data) ;
}

approveCWO(data) {
  return this.http.put(this.serviceApiUrl + "correctiveMaintenance/approve", data);
}

getByCWOById(id) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "correctiveMaintenance/id?id=" + id)
}

savePendingCompletionFilesCwo(
  data,
  file1,
  file2,
  file3,
) {
  const formData: FormData = new FormData();
  formData.append("workRequestStringObj", JSON.stringify(data));
  formData.append("checkList", file2);
  formData.append("electricityReportFile", file3);
  formData.append("file3", file1);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}/correctiveMaintenance/approveWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

otrRequestCwo(data) {
  return this.http.put(this.serviceApiUrl + "correctiveMaintenance/otrRaise", data);
}
deleteTechnicianMapping(qubesUserId,reporteeId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubesTsdHierarchy/deleteMapping?qubesUserId=" + qubesUserId + "&reporteeId=" + reporteeId);
}
deleteCicMapping(qubesUserId,reporteeId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubesTsdHierarchy/deleteCICMapping?qubesUserId=" + qubesUserId + "&reporteeId=" + reporteeId);
}
saveModifiedCic(oldUserId,newUserId,reporteeId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/updateCICMapping?oldUserId=" + oldUserId + "&newUserId=" + newUserId,+ "&reporteeId=" + reporteeId);
}

getProblemIdentifiedAll(problemName){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "problemIdentified/getByProblemReportedName?name=" + problemName);
}
 getProblemReportedAll(beCategoryId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "problemReported/getByBeCategoryId?id="+beCategoryId);
}
saveModifiedSpec(oldUserId,newUserId,reporteeId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/updateSpecialistMapping?oldUserId=" + oldUserId + "&newUserId=" + newUserId,+ "&reporteeId=" + reporteeId);
}
fetchAllAgm(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/fetchByAGM");
}
fetchSmByAgmId(agmUserId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/getAGMReportes?agmUserId=" + agmUserId);
}
deleteStockMapping(stockId,assetCategoryId,beCodeAndManufacturerId){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/getAGMReportes?stockId=" + stockId + "&assetCategoryId=" + assetCategoryId,+ "&beCodeAndManufacturerId=" + beCodeAndManufacturerId);
}
updatestockmasters(stockMaster) {
  return this.http.put<Observable<any>>(this.serviceApiUrl + "stockMaster/updateStocksAndItsMapping", stockMaster);
}
fetchBybeyond(stateId, districtId, clinicCategoryId, clinicId, year, month,page,size,sortBy,sortDirection,searchValue) {
  let urlString = "workRequestTsd/pbrandBerReport?stateId=" + stateId

  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (page != null && page != '' && page != undefined) {
    urlString += "&page=" + page
  }
  if (size != null && size != '' && size != undefined) {
    urlString += "&size=" + size
  }
  if (sortBy != null && sortBy != '' && sortBy != undefined) {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != '' && sortDirection != undefined) {
    urlString += "&sortDirection=" + sortDirection
  }
  if (searchValue != null && searchValue != '' && searchValue != undefined) {
    urlString += "&searchValue=" + searchValue
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
fetchBybeyondpdfexcel(stateId, districtId, clinicCategoryId, clinicId, year, month,page,size,sortBy,sortDirection,searchValue) {
  let urlString = "workRequestTsd/pberAndBerReportForExcelAndPdf?stateId=" + stateId

  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (page != null && page != '' && page != undefined) {
    urlString += "&page=" + page
  }
  if (size != null && size != '' && size != undefined) {
    urlString += "&size=" + size
  }
  if (sortBy != null && sortBy != '' && sortBy != undefined) {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != '' && sortDirection != undefined) {
    urlString += "&sortDirection=" + sortDirection
  }
  if (searchValue != null && searchValue != '' && searchValue != undefined) {
    urlString += "&searchValue=" + searchValue
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

fetchBysummary(stateId, districtId, clinicCategoryId, clinicId, year, month,page,size,sortBy,sortDirection,searchValue) {
  let urlString = "bdmkpi/overAllPenaltyReport?stateId=" + stateId

  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (page != null && page != '' && page != undefined) {
    urlString += "&page=" + page
  }
  if (size != null && size != '' && size != undefined) {
    urlString += "&size=" + size
  }
  if (sortBy != null && sortBy != '' && sortBy != undefined) {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != '' && sortDirection != undefined) {
    urlString += "&sortDirection=" + sortDirection
  }
  if (searchValue != null && searchValue != '' && searchValue != undefined) {
    urlString += "&searchValue=" + searchValue
  }



  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

fetchBysummarynewapi(stateId, districtId, clinicCategoryId, clinicId, year, month,page,size,sortBy,sortDirection,searchValue) {
  let urlString = "bdmkpi/overAllPenaltyReportForExcelAndPdf?stateId=" + stateId

  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (districtId != null && districtId != '' && districtId != undefined) {
    urlString += "&districtId=" + districtId
  }

  if (clinicId != null && clinicId != '' && clinicId != undefined) {
    urlString += "&clinicId=" + clinicId
  }
  if (year != null && year != '' && year != undefined) {
    urlString += "&year=" + year
  }

  if (month != null && month != '' && month != undefined) {
    urlString += "&month=" + month
  }
  if (page != null && page != '' && page != undefined) {
    urlString += "&page=" + page
  }
  if (size != null && size != '' && size != undefined) {
    urlString += "&size=" + size
  }
  if (sortBy != null && sortBy != '' && sortBy != undefined) {
    urlString += "&sortBy=" + sortBy
  }
  if (sortDirection != null && sortDirection != '' && sortDirection != undefined) {
    urlString += "&sortDirection=" + sortDirection
  }
  if (searchValue != null && searchValue != '' && searchValue != undefined) {
    urlString += "&searchValue=" + searchValue
  }



  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}


fetchByScheduleMaintenanceSP(clinicTypeId, clinicCategoryId, stateId, districtId, circleId) {

  let urlString = "scheduleMaintenanceSp/findByClinicCategoryAndType?stateId=" + stateId

  if (clinicCategoryId != null && clinicCategoryId != '') {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }
  if (clinicTypeId != null && clinicTypeId != '') {
    urlString += "&clinicTypeId=" + clinicTypeId
  }

  if (districtId != null && districtId != '') {
    urlString += "&districtId=" + districtId
  }

  if (circleId != null && circleId != '') {
    urlString += "&circleId=" + circleId
  }


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);

}

fetchByScheduleMaintenanceSaveSP(mAssetId, statutoryInspectionDate, statutoryExpiryDate, jkkpCertificateNumber) {

  let data = ""
  if (mAssetId != null && mAssetId != "" && mAssetId != undefined) {
    data += "id=" + mAssetId + "&"
  }
  if (statutoryInspectionDate != null && statutoryInspectionDate != "" && statutoryInspectionDate != undefined) {
    data += "statutoryInspectionDate=" + statutoryInspectionDate + "&"
  }
  if (statutoryExpiryDate != null && statutoryExpiryDate != "" && statutoryExpiryDate != undefined) {
    data += "statutoryExpiryDate=" + statutoryExpiryDate + "&"
  }
  if (jkkpCertificateNumber != null && jkkpCertificateNumber != "" && jkkpCertificateNumber != undefined) {
    data += "jkkpCertificateNumber=" + jkkpCertificateNumber + "&"
  }
  return this.http.get(this.serviceApiUrl + 'scheduleMaintenanceSp/updateDetails?' + data);

  // return this.http.get(this.serviceApiUrl + "mAsset/updateSchedulingDate?mAssetId=" + mAssetId + "&scheduledDate=" + scheduledDate + "&scheduledDate2=" + scheduledDate2 + "&status=y&remarks=" + remarks);

}

approveScheduleStatusSP(data, stateCode, circleCode) {
  return this.http.put<Observable<any>>(this.serviceApiUrl + "scheduleMaintenanceSp/approve?stateCode=" + stateCode + "&circleCode=" + circleCode, data);
}

fetchgroupBySMRefNumberSP() {
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/fetchgroupBySMRefNumber");
  return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenanceSp/all");
}

forwardSMPlanSP(circleRefNumber, serviceApiUrl) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenanceSp/approveStateManager?circleRefNumber=" + circleRefNumber + '&serviceApiUrl=' + serviceApiUrl)
}


fetchByFilteredForLocationSP(stateId,districtId, clinicCategoryId, clinicTypeId, circleId, clinicId) {
  let periodMonth = new Date().getMonth() + 2;
  periodMonth = periodMonth == 13 ? 1 : periodMonth

  let url: string = "spWorkOrder/filterByLocation?month=" + periodMonth

  if (stateId != null || stateId != '') {
    url += "&stateId=" + stateId
  }

  if (districtId != null || districtId != '') {
    url += "&districtId=" + districtId
  }
  if (clinicCategoryId != null || clinicCategoryId != '') {
    url += "&clinicCategoryId=" + clinicCategoryId
  }

  if (circleId != null || circleId != '') {
    url += "&circleId=" + circleId
  }

  if (clinicTypeId != null || clinicTypeId != '') {
    url += "&clinicTypeId=" + clinicTypeId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + url);
}


fetchByFilteredForBECategorySP(workGroupId, ownershipId, beCategoryId, stateId, circleId) {
  let periodMonth = new Date().getMonth() + 2;
  periodMonth = periodMonth == 13 ? 1 : periodMonth


  let urlString: string = "month=" + periodMonth 

  if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "&stateId=" + stateId
  }
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  // 
  if (workGroupId != null && workGroupId != '' && workGroupId != undefined) {
    urlString += "&workGroupId=" + workGroupId
  }
  if (ownershipId != null && ownershipId != '' && ownershipId != undefined) {
    urlString += "&ownershipId=" + ownershipId
  }
  if (beCategoryId != null && beCategoryId != '' && beCategoryId != undefined) {
    urlString += "&beCategoryId=" + beCategoryId
  }
  console.log("hello", urlString)
  return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/filterByCategory?" + urlString);
}


fetchAllAssetsByDistrictAndClinicSP(clinicId) {

  return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/findByClinic?clinicId=" + clinicId);
}


findByCategorySP(assetCategoryId, stateId, circleId) {

  let urlString: string = "assetCategoryId=" + assetCategoryId

  if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "&stateId=" + stateId
  }
  if (circleId != null && circleId != '' && circleId != undefined) {
    urlString += "&circleId=" + circleId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/findByCategory?" + urlString);
}

approveAssignedSP(stateId, districtId, circleId, month, serviceApiUrl) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/approveAssigned?stateId=" + stateId + "&districtId=" + districtId + "&circleId=" + circleId + "&month=" + month + '&serviceApiUrl=' + serviceApiUrl);
}

assignSMWorkOrderSP(assignSMWorkOrder) {
  return this.http.post<Observable<any>>(this.serviceApiUrl + "spWorkOrder/assignSMWorkOrder", assignSMWorkOrder);
}


fetchAllTechWoCountSP(userId, stateId, circleId, districtId, clinicId) {
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchCountWorkOrder?userId=" + userId);
  let strUrl = this.serviceApiUrl + "spWorkOrder/fetchCountWorkOrder?"

  if (stateId) {
    strUrl += "stateId=" + stateId + "&"
  }
  if (circleId) {
    strUrl += "circleId=" + circleId + "&"
  }
  if (districtId) {
    strUrl += "districtId=" + districtId + "&"
  }
  if (clinicId) {
    strUrl += "clinicId=" + clinicId + "&"
  }
  if (userId) {
    strUrl += "userId=" + userId + "&"
  }
  return this.http.get<Observable<any>>(strUrl);
}

fetchAllTechWONotAckPaginationSP(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/fetchWorkRequestWorkOrderPagination?" + data) ;
}

getByWrunAssignedByPPMIdSP(id) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/id?id=" + id)
}


approveTechWorkOrderSP(data) {
  return this.http.put(this.serviceApiUrl + "spWorkOrder/approve", data)
}

rejectTechWRunAssignedSP(data) {
  return this.http.put<Observable<any>>(this.serviceApiUrl + "spWorkOrder/reject", data);
}

completePpmWoWithPbrToActStageSP(
  data,
  pberDoc,
) {
  const formData: FormData = new FormData();
  formData.append("stringObject", JSON.stringify(data));
  formData.append("pberDoc", pberDoc);
  console.log("Support document", pberDoc)
  
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}spWorkOrder/approveAct`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
completePpmWoWithPbrToBerStageSP(
  data,
  pberDoc,
) {
  const formData: FormData = new FormData();
  formData.append("stringObject", JSON.stringify(data));
  formData.append("pberDoc", pberDoc);
  console.log("Support document", pberDoc)
  
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}spWorkOrder/approvePBER`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

fetchPPMMInprogressSortingSP(tabSetStatus,userId,page,size,sortBy,sortDirection,searchValue,isHighlighted) {
  let data = ""
  if (tabSetStatus != null && tabSetStatus != "") {
    data += "tabSetStatus=" + tabSetStatus + "&"
  }
  if (userId != null && userId != "") {
    data += "userId=" + userId + "&"
  }
  if (page != null && page != "") {
    data += "page=" + page + "&"
  }
  if (size != null && size != "") {
    data += "size=" + size + "&"
  }
  if (sortBy != null && sortBy != "") {
    data += "sortBy=" + sortBy + "&"
  }
  if (sortDirection != null && sortDirection != "") {
    data += "sortDirection=" + sortDirection + "&"
  }
  if (searchValue != null && searchValue != "") {
    data += "searchValue=" + searchValue + "&"
  }
  if (isHighlighted != null && isHighlighted != "") {
    data += "isHighlighted=" + isHighlighted 
  }
  // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchWorkRequestWorkOrderPagination?tabSetStatus=woNotAcknowledged&userId=" + userId+"&page="+page +"&size="+size+"&sortBy="+sortBy);
  return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/sortByColorPPM?" + data) ;
}

savePendingCompletionFilesSP(
  data,
  file1,
  file2,
  file3,
) {
  const formData: FormData = new FormData();
  formData.append("workRequestStringObj", JSON.stringify(data));
  formData.append("checkList", file2);
  formData.append("electricityReportFile", file3);
  formData.append("file3", file1);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}spWorkOrder/approveWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}

savePpmProposedForBERWithFilesSP(
  data,
  categoryCheckList,
  electricSafetyReport,
  otherDocument,
  formB12
) {
  const formData: FormData = new FormData();
  formData.append("workRequestStringObj", JSON.stringify(data));
  formData.append("checkList", categoryCheckList);
  formData.append("electricityReportFile", electricSafetyReport);
  formData.append("file3", otherDocument);
  formData.append("formB12", formB12);
  const req = new HttpRequest(
    "PUT",
    `${this.serviceApiUrl}spWorkOrder/approveWithFile`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
fetchBecodeManufacturer(assetCategoryId, manufacturerId, modelName) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "obsoleteEquipmentModel/woList?assetCategoryId=" + assetCategoryId + "&manufacturerId=" + manufacturerId + "&modelName=" + modelName)
}
fetchBecodeManufacturerByManufacturer(assetCategoryId, manufacturerId) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "obsoleteEquipmentModel/woListForManufacturer?assetCategoryId=" + assetCategoryId + "&manufacturerId=" + manufacturerId)
}
completeObsoleteEquipment(
  data,
  obsoleteModel,
) {
  const formData: FormData = new FormData();
  formData.append("stringObject", JSON.stringify(data));
  formData.append("obsoleteModel", obsoleteModel);
  
  const req = new HttpRequest(
    "POST",
    `${this.serviceApiUrl}obsoleteEquipmentModel/add`,
    formData,
    {
      reportProgress: true,
      responseType: "json",
    }
  );
  return this.http.request(req);
}
fetchTableDataObsolete(){
  return this.http.get<Observable<any>>(this.serviceApiUrl + "obsoleteEquipmentModel/fetchGroupedDate")
}
fetchByObsoleteRefNumber(refNumber) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "obsoleteEquipmentModel/fetchAllOpenWoByRefNumber?refNumber=" + refNumber)
}
approveByObsoleteRefNumber(refNumber) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "obsoleteEquipmentModel/approve?refNumber=" + refNumber)
}fetchReportessForTtft(userId) {
  return this.http.get(this.serviceApiUrl + "qubesTsdHierarchy/fetchReportessForTtft?id=" + userId);
}
fetchPrReport(storeLocationId,stockTypeId) {
  return this.http.get(this.serviceApiUrl + "prAgingReport/fetchPrAgingReport?storeLocationId=" + storeLocationId + "&stockTypeId=" + stockTypeId);
}
fetchPrReportExcelPdf(storeLocationId,stockTypeId) {
  return this.http.get(this.serviceApiUrl + "prAgingReport/prAgingReportExcelAndPdf?storeLocationId=" + storeLocationId + "&stockTypeId=" + stockTypeId);
}
fetchPartiallyPrData(prNumber,stockId) {
  return this.http.get(this.serviceApiUrl + "prAgingReport/getPartiallyPrData?prNumber=" + prNumber+"&stockId=" + stockId);
}
fetchStockReconciliationReportData(storeLocationId,stockTypeId) {
  let data = ""
  if (storeLocationId != null && storeLocationId != "") {
    data += "storeLocationId=" + storeLocationId + "&"
  }
  if (stockTypeId != null && stockTypeId != "") {
    data += "stockTypeId=" + stockTypeId + "&"
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "stockReconciliation/fetchStockReconciliationReport?storeLocationId?" + data) ;
}
fetchAllAssetsByStateId(stateId) {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/findByState?stateId=" + stateId);
}
assignApproveLeWorkOrder(assignLEWorkOrder:any) {
  return this.http.post<Observable<any>>(this.serviceApiUrl + "leWorkOrder/assignLEWorkOrder", assignLEWorkOrder);
}

verifyTheAssignedAssets(month,stateId){
  let urlString: string =  "leWorkOrder/approveAssigned?month="+month
  if(stateId != null && stateId!='' && stateId != 0 ){
    urlString +="&stateId=" + stateId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}
// verifyTheAssignedAssets(data: any) {
//   let queryParams = '';
//   // Construct query parameters dynamically
//   if (data.stateId) {
//     queryParams += `stateId=${data.stateId}&`;
//   }
//   if (data.month) {
//     queryParams += `month=${data.month}&`;
//   }
//   // Remove trailing '&' if it exists
//   queryParams = queryParams.endsWith('&') ? queryParams.slice(0, -1) : queryParams;
//   const apiUrl = `${this.serviceApiUrl}/leWorkOrder/approveAssigned?${queryParams}`;
//   return this.http.get(apiUrl);
// }
specLeWoekLoadByState(stateId) {
  let data = ""
  if (stateId != null && stateId != "" && stateId != undefined) {
    data += "stateId=" + stateId + "&"
  }
  return this.http.get(this.serviceApiUrl + 'leWorkOrder/specialistWorkLoadPpmbdm?' + data);
}
fetcLeTechWorkLoad() {
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/technicianWorkLoadPpmbdm");
}
findByCategoryLeWorkGen(assetCategoryId, stateId) {

  let urlString: any
  if (assetCategoryId != null && assetCategoryId != '' && assetCategoryId != undefined) {
    urlString += "&assetCategoryId=" + assetCategoryId
  }

  if (stateId != null && stateId != '' && stateId != undefined) {
    urlString += "&stateId=" + stateId
  }
 
  return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/findByCategory?" + urlString);
}
checkscheduleMaintenanceSpHoliday(assetId: number, scheduledDate: string, status: string) {
  return this.http.get<Observable<any>>(
    this.serviceApiUrl +"scheduleMaintenanceSp/checkHoliday?mAssetId=" + assetId +"&scheduledDate=" +scheduledDate +"&status=" +status
  );
} 

getTheCounts(stateId, circleId, districtId, clinicCategoryId) {

  let urlString = "scheduleMaintenanceSp/smCounter?"

  if (stateId != null && stateId != '' && stateId != 0) {
    urlString += "&stateId=" + stateId
  }
  if (circleId != null && circleId != '' && circleId != 0) {
    urlString += "&circleId=" + circleId
  }
  if (districtId != null && districtId != '' && districtId != 0) {
    urlString += "&districtId=" + districtId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != 0) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);

  // return this.http.get<Observable<any>>(this.serviceApiUrl + "scheduleMaintenance/smCounter");
}
fetchStockReconciliationAdjustmentData(storeLocationId,stockTypeId) {
  let data = ""
  if (storeLocationId != null && storeLocationId != "") {
    data += "storeLocationId=" + storeLocationId + "&"
  }
  if (stockTypeId != null && stockTypeId != "") {
    data += "stockTypeId=" + stockTypeId + "&"
  }
  return this.http.get<Observable<any>>(this.serviceApiUrl + "stockReconciliation/fetchDetailsForReconciliation?" + data) ;
}
saveStockAdjustmentData(
  data,
  file,
) {
  const formData: FormData = new FormData();
  formData.append("dataList", JSON.stringify(data));
  formData.append("file", file);
  return this.http.put(this.serviceApiUrl + "stockReconciliation/updateQuantity", formData);
}
fetchByProvisionalStatutoryScheduleMaintenanceplanpreview(clinicTypeId, clinicCategoryId, clinicCode) {
  let urlString = "scheduleMaintenanceSp/smPlan?"

  if (clinicTypeId != null && clinicTypeId != '' && clinicTypeId != undefined) {
    urlString += "&clinicTypeId=" + clinicTypeId
  }
  if (clinicCategoryId != null && clinicCategoryId != '' && clinicCategoryId != undefined) {
    urlString += "&clinicCategoryId=" + clinicCategoryId
  }

  if (clinicCode != null && clinicCode != '' && clinicCode != undefined) {
    urlString += "&clinicCode=" + clinicCode
  }

  


  return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
}

 currentMonthWiseForStatutory(smUserId,cicUserId) {

    let url: string = "spWorkOrder/currentMonthWiseForWoPPM?" 

    if (smUserId != null && smUserId != '' && smUserId != undefined) {
      url += "&smUserId=" + smUserId
    }

    if (cicUserId != null && cicUserId != '' && cicUserId != undefined) {
      url += "&cicUserId=" + cicUserId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + url);


    // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/currentMonthWiseForPPM");
  }
  fetchAllTechWoCountLeWorkOreder(userId, stateId, circleId, districtId, clinicId) {
    // return this.http.get<Observable<any>>(this.serviceApiUrl + "smWorkOrder/fetchCountWorkOrder?userId=" + userId);
    let strUrl = this.serviceApiUrl + "leWorkOrder/fetchCountWorkOrder?"
   
    if (stateId) {
      strUrl += "stateId=" + stateId + "&"
    }
    if (circleId) {
      strUrl += "circleId=" + circleId + "&"
    }
    if (districtId) {
      strUrl += "districtId=" + districtId + "&"
    }
    if (clinicId) {
      strUrl += "clinicId=" + clinicId + "&"
    }
    if (userId) {
      strUrl += "userId=" + userId + "&"
    }
    return this.http.get<Observable<any>>(strUrl);
  }
  WorkOrderGenerationExcelSp(stateId,circleId,month,year){
    let urlString = "spWorkOrder/woGenerationExcelDetails?"
    if (stateId != null && stateId != '' && stateId != 0) {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != 0) {
      urlString += "&circleId=" + circleId
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
   
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
  
  }
  WorkOrderGenerationExcelLe(stateId,circleId,month,year){
    let urlString = "leWorkOrder/woGenerationExcelDetails?"
    if (stateId != null && stateId != '' && stateId != 0) {
      urlString += "&stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != 0) {
      urlString += "&circleId=" + circleId
    }
    if (month != null && month != '') {
      urlString += "&month=" + month
    }
    if (year != null && year != '') {
      urlString += "&year=" + year
    }
   
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString)
  
  }
  fetchStockReconciliationRefNumber(refNumber){
    return this.http.get(this.serviceApiUrl + "stockReconciliation/fetchStockListByRefNumber?refNumber=" +refNumber);
  }
  fetchStockReconciliationReport(storeLocationId){
    return this.http.get(this.serviceApiUrl + "stockReconciliationLog/fetchByStoreLocation?storeLocationId=" +storeLocationId);
  }
  getByWrunAssignedBySPMId(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "spWorkOrder/id?id=" + id)
  }
  getByWrunAssignedByTEId(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "teBreakdownController/id?id=" + id)
  }
  getByTeId(id){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "teWorkOrder/id?id=" + id)
  }
  getByWrunAssignedByLEId(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "leBreakdownController/id?id=" + id)
  }
  getByWrunAssignedByLEPlanner(id) {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "leWorkOrder/id?id=" + id)
  }
  // fetchAllTTftRequestedData(stateId,circleId,districtId){
  //   return this.http.get<Observable<any>>(this.serviceApiUrl + "ttftServiceAuditController/fetchDataForTtftRequestFromBdmAndPpm?stateId=" + stateId  + "&circleId=" + circleId + "&districtId=" + districtId)
  // }
  saveUpdatedTtftRequest(data){
    return this.http.post<Observable<any>>(this.serviceApiUrl + "ttftServiceAuditController/addTtftServiceAudit", data);
  }
  fetchAllWorkRequestDataForExcelAndPdf(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    tabSetStatus,year,month) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (tabSetStatus != null && tabSetStatus != "") {
      data += "tabSetStatus=" + tabSetStatus + "&"
    }
    if (year != null && year != "") {
      data += "year=" + year + "&"
    }
    if (month != null && month != "") {
      data += "month=" + month + "&"
    }    
    return this.http.get<Observable<any>>(this.serviceApiUrl + "workRequestTsd/fetchWorkRequestWorkOrderForPdfAndExcel?" + data);
  }
  getFileList(workGroupId?: number, beCategoryId?: number) {
    let urlString = "ppmCheckList/getFilesList";
  
    if (workGroupId && workGroupId !== 0) {
      urlString += `?workGroupId=${workGroupId}`;
    }
    if (beCategoryId && beCategoryId !== 0) {
      urlString += workGroupId && workGroupId !== 0 ? `&beCategoryId=${beCategoryId}` : `?beCategoryId=${beCategoryId}`;
    }
  
    return this.http.get(this.serviceApiUrl + urlString);
  }
  downloadFilelist(id:any){
    return this.http.get<Blob>(this.serviceApiUrl+"ppmCheckList/downloadFile?id="+id, { responseType: 'blob' as 'json' })
  }
  uploadFile(workGroupId: number, formData: FormData) {
    return this.http.put(this.serviceApiUrl + `ppmCheckList/replaceExistingFile?id=${workGroupId}`, formData);
  }
  uploadFiles( beCategoryId: number,workGroupId: number,formData: FormData) {
    return this.http.post(this.serviceApiUrl + `ppmCheckList/addNewFiles?beCategoryId=${beCategoryId}&workGroupId=${workGroupId}`, formData);
  }
  fetchTTFTService(ppmId, bdmId) {
    let urlString = "ttftServiceAuditController/fetchMrDetailsForWo?" 
    if (ppmId != null && ppmId != '' && ppmId != undefined) {
      urlString += "ppmId=" + ppmId
    }
    if (bdmId != null && bdmId != '' && bdmId != undefined) {
      urlString += "bdmId=" + bdmId
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
  }

 fetchAllTTftRequestedData(stateId,circleId,districtId){
    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "ttftServiceAuditController/fetchDataForTtftRequestFromBdmAndPpm?" + data)
  }
  fetchAllTtftManager() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user/fetchTtftManager");
  }
} 

